// This file is auto-generated when running: npm run assets
// DO NOT EDIT MANUALLY!

import { CardglowAtlas } from './CardglowAtlas';
import { CardsBacks10CardBackCatCrownAtlas } from './CardsBacks10CardBackCatCrownAtlas';
import { CardsBacks11CardBackCatGlassesAtlas } from './CardsBacks11CardBackCatGlassesAtlas';
import { CardsBacks12CardBackMonarchDogAtlas } from './CardsBacks12CardBackMonarchDogAtlas';
import { CardsBacks13CardBackHappyCartoonDogAtlas } from './CardsBacks13CardBackHappyCartoonDogAtlas';
import { CardsBacks14CardBackWhitePuppyAtlas } from './CardsBacks14CardBackWhitePuppyAtlas';
import { CardsBacks15CardBackIslandAtlas } from './CardsBacks15CardBackIslandAtlas';
import { CardsBacks16CardBackCrownedDogAtlas } from './CardsBacks16CardBackCrownedDogAtlas';
import { CardsBacks17CardBackRosesAtlas } from './CardsBacks17CardBackRosesAtlas';
import { CardsBacks18CardBackSunflowersAtlas } from './CardsBacks18CardBackSunflowersAtlas';
import { CardsBacks19CardBackRosehipAtlas } from './CardsBacks19CardBackRosehipAtlas';
import { CardsBacks1CardBackBlueAtlas } from './CardsBacks1CardBackBlueAtlas';
import { CardsBacks20CardBackFloralPrintAtlas } from './CardsBacks20CardBackFloralPrintAtlas';
import { CardsBacks21CardBackOrchidsAtlas } from './CardsBacks21CardBackOrchidsAtlas';
import { CardsBacks22CardBackSakuraAtlas } from './CardsBacks22CardBackSakuraAtlas';
import { CardsBacks23CardBackBeeAtlas } from './CardsBacks23CardBackBeeAtlas';
import { CardsBacks24CardBackButterflyAtlas } from './CardsBacks24CardBackButterflyAtlas';
import { CardsBacks25CardBackLadybugAtlas } from './CardsBacks25CardBackLadybugAtlas';
import { CardsBacks26CardBackCalibriAtlas } from './CardsBacks26CardBackCalibriAtlas';
import { CardsBacks27CardBackOwlAtlas } from './CardsBacks27CardBackOwlAtlas';
import { CardsBacks28CardBackToucanAtlas } from './CardsBacks28CardBackToucanAtlas';
import { CardsBacks29CardBackSwanAtlas } from './CardsBacks29CardBackSwanAtlas';
import { CardsBacks2CardBackBlueDarkAtlas } from './CardsBacks2CardBackBlueDarkAtlas';
import { CardsBacks30CardBackBambooBearAtlas } from './CardsBacks30CardBackBambooBearAtlas';
import { CardsBacks31CardBackLeopardAtlas } from './CardsBacks31CardBackLeopardAtlas';
import { CardsBacks32CardBackLionAtlas } from './CardsBacks32CardBackLionAtlas';
import { CardsBacks33CardBackDeerAtlas } from './CardsBacks33CardBackDeerAtlas';
import { CardsBacks34CardBackPolarBearAtlas } from './CardsBacks34CardBackPolarBearAtlas';
import { CardsBacks35CardBackPagodaAtlas } from './CardsBacks35CardBackPagodaAtlas';
import { CardsBacks36CardBackYorkshireTerrierAtlas } from './CardsBacks36CardBackYorkshireTerrierAtlas';
import { CardsBacks37CardBackJapaneseSceneryAtlas } from './CardsBacks37CardBackJapaneseSceneryAtlas';
import { CardsBacks38CardBackMuseumAtlas } from './CardsBacks38CardBackMuseumAtlas';
import { CardsBacks39CardBackPalaceAtlas } from './CardsBacks39CardBackPalaceAtlas';
import { CardsBacks3CardBackRedAtlas } from './CardsBacks3CardBackRedAtlas';
import { CardsBacks40CardBackCastleAtlas } from './CardsBacks40CardBackCastleAtlas';
import { CardsBacks41CardBackWhiteDomeAtlas } from './CardsBacks41CardBackWhiteDomeAtlas';
import { CardsBacks42CardBackEiffelTowerAtlas } from './CardsBacks42CardBackEiffelTowerAtlas';
import { CardsBacks43CardBackHydrangeasAtlas } from './CardsBacks43CardBackHydrangeasAtlas';
import { CardsBacks44CardBackChineseWallAtlas } from './CardsBacks44CardBackChineseWallAtlas';
import { CardsBacks45CardBackAstrologyAtlas } from './CardsBacks45CardBackAstrologyAtlas';
import { CardsBacks46CardBackSkyAtlas } from './CardsBacks46CardBackSkyAtlas';
import { CardsBacks47CardBackShellsAtlas } from './CardsBacks47CardBackShellsAtlas';
import { CardsBacks48CardBackYachtAtlas } from './CardsBacks48CardBackYachtAtlas';
import { CardsBacks49CardBackPirateShipAtlas } from './CardsBacks49CardBackPirateShipAtlas';
import { CardsBacks4CardBackRedPatternAtlas } from './CardsBacks4CardBackRedPatternAtlas';
import { CardsBacks50CardBackCarSunsetAtlas } from './CardsBacks50CardBackCarSunsetAtlas';
import { CardsBacks51CardBackRetroCarAtlas } from './CardsBacks51CardBackRetroCarAtlas';
import { CardsBacks52CardBackAstronautAtlas } from './CardsBacks52CardBackAstronautAtlas';
import { CardsBacks53CardBackCartoonHatCatAtlas } from './CardsBacks53CardBackCartoonHatCatAtlas';
import { CardsBacks54CardBackFlowerGirlAtlas } from './CardsBacks54CardBackFlowerGirlAtlas';
import { CardsBacks55CardBackCandyAtlas } from './CardsBacks55CardBackCandyAtlas';
import { CardsBacks56CardBackPorscheAtlas } from './CardsBacks56CardBackPorscheAtlas';
import { CardsBacks57CardBackUmbrellasAtlas } from './CardsBacks57CardBackUmbrellasAtlas';
import { CardsBacks58CardBackChineseLanternAtlas } from './CardsBacks58CardBackChineseLanternAtlas';
import { CardsBacks59CardBackGoldenCrownAtlas } from './CardsBacks59CardBackGoldenCrownAtlas';
import { CardsBacks5CardBackBluePatternAtlas } from './CardsBacks5CardBackBluePatternAtlas';
import { CardsBacks60CardBackPurpleCrownAtlas } from './CardsBacks60CardBackPurpleCrownAtlas';
import { CardsBacks61CardBackChinesePalaceAtlas } from './CardsBacks61CardBackChinesePalaceAtlas';
import { CardsBacks62CardBackGiftAtlas } from './CardsBacks62CardBackGiftAtlas';
import { CardsBacks63CardBackWinterDogAtlas } from './CardsBacks63CardBackWinterDogAtlas';
import { CardsBacks64CardBackSnowflakesAtlas } from './CardsBacks64CardBackSnowflakesAtlas';
import { CardsBacks65CardBackGoldenBirdAtlas } from './CardsBacks65CardBackGoldenBirdAtlas';
import { CardsBacks66CardBackSpiderAtlas } from './CardsBacks66CardBackSpiderAtlas';
import { CardsBacks67CardBackHeartFlowersAtlas } from './CardsBacks67CardBackHeartFlowersAtlas';
import { CardsBacks68CardBackHeartCatAtlas } from './CardsBacks68CardBackHeartCatAtlas';
import { CardsBacks69CardBackHeartGlassesAtlas } from './CardsBacks69CardBackHeartGlassesAtlas';
import { CardsBacks6CardBackOrangeAtlas } from './CardsBacks6CardBackOrangeAtlas';
import { CardsBacks70CardBackHeartDogAtlas } from './CardsBacks70CardBackHeartDogAtlas';
import { CardsBacks71CardBackClassicBlueAtlas } from './CardsBacks71CardBackClassicBlueAtlas';
import { CardsBacks72CardBackClassicPurpleAtlas } from './CardsBacks72CardBackClassicPurpleAtlas';
import { CardsBacks73CardBackClassicRedAtlas } from './CardsBacks73CardBackClassicRedAtlas';
import { CardsBacks74CardBackPandaAtlas } from './CardsBacks74CardBackPandaAtlas';
import { CardsBacks75CardBackPandaLeavesAtlas } from './CardsBacks75CardBackPandaLeavesAtlas';
import { CardsBacks76CardBackPalaceAtlas } from './CardsBacks76CardBackPalaceAtlas';
import { CardsBacks77CardBackHalloweenAtlas } from './CardsBacks77CardBackHalloweenAtlas';
import { CardsBacks78CardBackAutumnAtlas } from './CardsBacks78CardBackAutumnAtlas';
import { CardsBacks79CardBackHalloweenCastleAtlas } from './CardsBacks79CardBackHalloweenCastleAtlas';
import { CardsBacks7CardBackGingerKittenAtlas } from './CardsBacks7CardBackGingerKittenAtlas';
import { CardsBacks80CardBackHalloweenPumpkinAtlas } from './CardsBacks80CardBackHalloweenPumpkinAtlas';
import { CardsBacks81CardBackHalloweenMoonAtlas } from './CardsBacks81CardBackHalloweenMoonAtlas';
import { CardsBacks82CardBackHalloweenMushroomAtlas } from './CardsBacks82CardBackHalloweenMushroomAtlas';
import { CardsBacks8CardBackCatHeadAtlas } from './CardsBacks8CardBackCatHeadAtlas';
import { CardsBacks9CardBackChineseCatAtlas } from './CardsBacks9CardBackChineseCatAtlas';
import { CardsFront10Cartoonish0Atlas } from './CardsFront10Cartoonish0Atlas';
import { CardsFront10Cartoonish1Atlas } from './CardsFront10Cartoonish1Atlas';
import { CardsFront10Cartoonish2Atlas } from './CardsFront10Cartoonish2Atlas';
import { CardsFront10Cartoonish3Atlas } from './CardsFront10Cartoonish3Atlas';
import { CardsFront10Cartoonish4Atlas } from './CardsFront10Cartoonish4Atlas';
import { CardsFront10Cartoonish5Atlas } from './CardsFront10Cartoonish5Atlas';
import { CardsFront10Cartoonish6Atlas } from './CardsFront10Cartoonish6Atlas';
import { CardsFront10Cartoonish7Atlas } from './CardsFront10Cartoonish7Atlas';
import { CardsFront10Cartoonish8Atlas } from './CardsFront10Cartoonish8Atlas';
import { CardsFront11WhiteLarge0Atlas } from './CardsFront11WhiteLarge0Atlas';
import { CardsFront11WhiteLarge1Atlas } from './CardsFront11WhiteLarge1Atlas';
import { CardsFront11WhiteLarge2Atlas } from './CardsFront11WhiteLarge2Atlas';
import { CardsFront11WhiteLarge3Atlas } from './CardsFront11WhiteLarge3Atlas';
import { CardsFront11WhiteLarge4Atlas } from './CardsFront11WhiteLarge4Atlas';
import { CardsFront12ClassicLarge0Atlas } from './CardsFront12ClassicLarge0Atlas';
import { CardsFront12ClassicLarge1Atlas } from './CardsFront12ClassicLarge1Atlas';
import { CardsFront12ClassicLarge2Atlas } from './CardsFront12ClassicLarge2Atlas';
import { CardsFront12ClassicLarge3Atlas } from './CardsFront12ClassicLarge3Atlas';
import { CardsFront12ClassicLarge4Atlas } from './CardsFront12ClassicLarge4Atlas';
import { CardsFront13Classic0Atlas } from './CardsFront13Classic0Atlas';
import { CardsFront13Classic1Atlas } from './CardsFront13Classic1Atlas';
import { CardsFront13Classic2Atlas } from './CardsFront13Classic2Atlas';
import { CardsFront13Classic3Atlas } from './CardsFront13Classic3Atlas';
import { CardsFront13Classic4Atlas } from './CardsFront13Classic4Atlas';
import { CardsFront1White0Atlas } from './CardsFront1White0Atlas';
import { CardsFront1White1Atlas } from './CardsFront1White1Atlas';
import { CardsFront1White2Atlas } from './CardsFront1White2Atlas';
import { CardsFront1White3Atlas } from './CardsFront1White3Atlas';
import { CardsFront1White4Atlas } from './CardsFront1White4Atlas';
import { CardsFront1White5Atlas } from './CardsFront1White5Atlas';
import { CardsFront1White6Atlas } from './CardsFront1White6Atlas';
import { CardsFront1White7Atlas } from './CardsFront1White7Atlas';
import { CardsFront1White8Atlas } from './CardsFront1White8Atlas';
import { CardsFront2Ivory0Atlas } from './CardsFront2Ivory0Atlas';
import { CardsFront2Ivory1Atlas } from './CardsFront2Ivory1Atlas';
import { CardsFront2Ivory2Atlas } from './CardsFront2Ivory2Atlas';
import { CardsFront2Ivory3Atlas } from './CardsFront2Ivory3Atlas';
import { CardsFront2Ivory4Atlas } from './CardsFront2Ivory4Atlas';
import { CardsFront2Ivory5Atlas } from './CardsFront2Ivory5Atlas';
import { CardsFront2Ivory6Atlas } from './CardsFront2Ivory6Atlas';
import { CardsFront2Ivory7Atlas } from './CardsFront2Ivory7Atlas';
import { CardsFront2Ivory8Atlas } from './CardsFront2Ivory8Atlas';
import { CardsFront3Medieval0Atlas } from './CardsFront3Medieval0Atlas';
import { CardsFront3Medieval1Atlas } from './CardsFront3Medieval1Atlas';
import { CardsFront3Medieval2Atlas } from './CardsFront3Medieval2Atlas';
import { CardsFront3Medieval3Atlas } from './CardsFront3Medieval3Atlas';
import { CardsFront3Medieval4Atlas } from './CardsFront3Medieval4Atlas';
import { CardsFront3Medieval5Atlas } from './CardsFront3Medieval5Atlas';
import { CardsFront3Medieval6Atlas } from './CardsFront3Medieval6Atlas';
import { CardsFront3Medieval7Atlas } from './CardsFront3Medieval7Atlas';
import { CardsFront3Medieval8Atlas } from './CardsFront3Medieval8Atlas';
import { CardsFront4Gothic0Atlas } from './CardsFront4Gothic0Atlas';
import { CardsFront4Gothic1Atlas } from './CardsFront4Gothic1Atlas';
import { CardsFront4Gothic2Atlas } from './CardsFront4Gothic2Atlas';
import { CardsFront4Gothic3Atlas } from './CardsFront4Gothic3Atlas';
import { CardsFront4Gothic4Atlas } from './CardsFront4Gothic4Atlas';
import { CardsFront4Gothic5Atlas } from './CardsFront4Gothic5Atlas';
import { CardsFront4Gothic6Atlas } from './CardsFront4Gothic6Atlas';
import { CardsFront4Gothic7Atlas } from './CardsFront4Gothic7Atlas';
import { CardsFront4Gothic8Atlas } from './CardsFront4Gothic8Atlas';
import { CardsFront5Cats0Atlas } from './CardsFront5Cats0Atlas';
import { CardsFront5Cats1Atlas } from './CardsFront5Cats1Atlas';
import { CardsFront5Cats2Atlas } from './CardsFront5Cats2Atlas';
import { CardsFront5Cats3Atlas } from './CardsFront5Cats3Atlas';
import { CardsFront5Cats4Atlas } from './CardsFront5Cats4Atlas';
import { CardsFront5Cats5Atlas } from './CardsFront5Cats5Atlas';
import { CardsFront5Cats6Atlas } from './CardsFront5Cats6Atlas';
import { CardsFront5Cats7Atlas } from './CardsFront5Cats7Atlas';
import { CardsFront5Cats8Atlas } from './CardsFront5Cats8Atlas';
import { CardsFront6Dogs0Atlas } from './CardsFront6Dogs0Atlas';
import { CardsFront6Dogs1Atlas } from './CardsFront6Dogs1Atlas';
import { CardsFront6Dogs2Atlas } from './CardsFront6Dogs2Atlas';
import { CardsFront6Dogs3Atlas } from './CardsFront6Dogs3Atlas';
import { CardsFront6Dogs4Atlas } from './CardsFront6Dogs4Atlas';
import { CardsFront6Dogs5Atlas } from './CardsFront6Dogs5Atlas';
import { CardsFront6Dogs6Atlas } from './CardsFront6Dogs6Atlas';
import { CardsFront6Dogs7Atlas } from './CardsFront6Dogs7Atlas';
import { CardsFront6Dogs8Atlas } from './CardsFront6Dogs8Atlas';
import { CardsFront7Elegant0Atlas } from './CardsFront7Elegant0Atlas';
import { CardsFront7Elegant1Atlas } from './CardsFront7Elegant1Atlas';
import { CardsFront7Elegant2Atlas } from './CardsFront7Elegant2Atlas';
import { CardsFront7Elegant3Atlas } from './CardsFront7Elegant3Atlas';
import { CardsFront7Elegant4Atlas } from './CardsFront7Elegant4Atlas';
import { CardsFront7Elegant5Atlas } from './CardsFront7Elegant5Atlas';
import { CardsFront7Elegant6Atlas } from './CardsFront7Elegant6Atlas';
import { CardsFront7Elegant7Atlas } from './CardsFront7Elegant7Atlas';
import { CardsFront7Elegant8Atlas } from './CardsFront7Elegant8Atlas';
import { CardsFront8Neon0Atlas } from './CardsFront8Neon0Atlas';
import { CardsFront8Neon1Atlas } from './CardsFront8Neon1Atlas';
import { CardsFront8Neon2Atlas } from './CardsFront8Neon2Atlas';
import { CardsFront8Neon3Atlas } from './CardsFront8Neon3Atlas';
import { CardsFront8Neon4Atlas } from './CardsFront8Neon4Atlas';
import { CardsFront8Neon5Atlas } from './CardsFront8Neon5Atlas';
import { CardsFront8Neon6Atlas } from './CardsFront8Neon6Atlas';
import { CardsFront8Neon7Atlas } from './CardsFront8Neon7Atlas';
import { CardsFront8Neon8Atlas } from './CardsFront8Neon8Atlas';
import { CardsFront9Retro0Atlas } from './CardsFront9Retro0Atlas';
import { CardsFront9Retro1Atlas } from './CardsFront9Retro1Atlas';
import { CardsFront9Retro2Atlas } from './CardsFront9Retro2Atlas';
import { CardsFront9Retro3Atlas } from './CardsFront9Retro3Atlas';
import { CardsFront9Retro4Atlas } from './CardsFront9Retro4Atlas';
import { CardsFront9Retro5Atlas } from './CardsFront9Retro5Atlas';
import { CardsFront9Retro6Atlas } from './CardsFront9Retro6Atlas';
import { CardsFront9Retro7Atlas } from './CardsFront9Retro7Atlas';
import { CardsFront9Retro8Atlas } from './CardsFront9Retro8Atlas';
import { CardsShadowAtlas } from './CardsShadowAtlas';
import { Desktop10DarkGreenAtlas } from './Desktop10DarkGreenAtlas';
import { Desktop11PoppiesAtlas } from './Desktop11PoppiesAtlas';
import { Desktop12GreenFieldAtlas } from './Desktop12GreenFieldAtlas';
import { Desktop13WaterfallAtlas } from './Desktop13WaterfallAtlas';
import { Desktop14BeachAtlas } from './Desktop14BeachAtlas';
import { Desktop15TurquoiseSkiesAtlas } from './Desktop15TurquoiseSkiesAtlas';
import { Desktop1GreenAtlas } from './Desktop1GreenAtlas';
import { Desktop20WoodAtlas } from './Desktop20WoodAtlas';
import { Desktop21PeonyAtlas } from './Desktop21PeonyAtlas';
import { Desktop22LonelyMountainAtlas } from './Desktop22LonelyMountainAtlas';
import { Desktop23FiveCatsAtlas } from './Desktop23FiveCatsAtlas';
import { Desktop24RoadAtlas } from './Desktop24RoadAtlas';
import { Desktop25NewYorkAtlas } from './Desktop25NewYorkAtlas';
import { Desktop26BlossomAtlas } from './Desktop26BlossomAtlas';
import { Desktop27CloudsAtlas } from './Desktop27CloudsAtlas';
import { Desktop28MountainLakeAtlas } from './Desktop28MountainLakeAtlas';
import { Desktop2BlueAtlas } from './Desktop2BlueAtlas';
import { Desktop30KittensAtlas } from './Desktop30KittensAtlas';
import { Desktop31MountainsAtlas } from './Desktop31MountainsAtlas';
import { Desktop32PaintedWallAtlas } from './Desktop32PaintedWallAtlas';
import { Desktop33WinterNightAtlas } from './Desktop33WinterNightAtlas';
import { Desktop34ChristmasTreeAtlas } from './Desktop34ChristmasTreeAtlas';
import { Desktop35WinterHouseAtlas } from './Desktop35WinterHouseAtlas';
import { Desktop36ChristmasWallAtlas } from './Desktop36ChristmasWallAtlas';
import { Desktop37HeartRosesAtlas } from './Desktop37HeartRosesAtlas';
import { Desktop38HeartDogsAtlas } from './Desktop38HeartDogsAtlas';
import { Desktop39FieldAtlas } from './Desktop39FieldAtlas';
import { Desktop3RedAtlas } from './Desktop3RedAtlas';
import { Desktop40MountainsLakeAtlas } from './Desktop40MountainsLakeAtlas';
import { Desktop41NightSkyAtlas } from './Desktop41NightSkyAtlas';
import { Desktop42NationalParkAtlas } from './Desktop42NationalParkAtlas';
import { Desktop43SakuraAtlas } from './Desktop43SakuraAtlas';
import { Desktop44BridgeAtlas } from './Desktop44BridgeAtlas';
import { Desktop45HalloweenSkyAtlas } from './Desktop45HalloweenSkyAtlas';
import { Desktop46AutumnAtlas } from './Desktop46AutumnAtlas';
import { Desktop47HalloweenFogAtlas } from './Desktop47HalloweenFogAtlas';
import { Desktop48HalloweenPumpkinAtlas } from './Desktop48HalloweenPumpkinAtlas';
import { Desktop49LeavesAtlas } from './Desktop49LeavesAtlas';
import { Desktop4OrangeAtlas } from './Desktop4OrangeAtlas';
import { Desktop50HalloweenStillLifeAtlas } from './Desktop50HalloweenStillLifeAtlas';
import { Desktop5OliveAtlas } from './Desktop5OliveAtlas';
import { Desktop6TurquoiseAtlas } from './Desktop6TurquoiseAtlas';
import { Desktop7BurgundyAtlas } from './Desktop7BurgundyAtlas';
import { Desktop8DarkPurpleAtlas } from './Desktop8DarkPurpleAtlas';
import { Desktop9PurpleAtlas } from './Desktop9PurpleAtlas';
import { Mobile10DarkGreenAtlas } from './Mobile10DarkGreenAtlas';
import { Mobile12GreenFieldAtlas } from './Mobile12GreenFieldAtlas';
import { Mobile13WaterfallAtlas } from './Mobile13WaterfallAtlas';
import { Mobile14BeachAtlas } from './Mobile14BeachAtlas';
import { Mobile15TurquoiseSkiesAtlas } from './Mobile15TurquoiseSkiesAtlas';
import { Mobile1GreenAtlas } from './Mobile1GreenAtlas';
import { Mobile20WoodAtlas } from './Mobile20WoodAtlas';
import { Mobile21PeonyAtlas } from './Mobile21PeonyAtlas';
import { Mobile22LonelyMountainAtlas } from './Mobile22LonelyMountainAtlas';
import { Mobile23FiveCatsAtlas } from './Mobile23FiveCatsAtlas';
import { Mobile24RoadAtlas } from './Mobile24RoadAtlas';
import { Mobile25NewYorkAtlas } from './Mobile25NewYorkAtlas';
import { Mobile26BlossomAtlas } from './Mobile26BlossomAtlas';
import { Mobile27CloudsAtlas } from './Mobile27CloudsAtlas';
import { Mobile28MountainLakeAtlas } from './Mobile28MountainLakeAtlas';
import { Mobile2BlueAtlas } from './Mobile2BlueAtlas';
import { Mobile30KittensAtlas } from './Mobile30KittensAtlas';
import { Mobile31MountainsAtlas } from './Mobile31MountainsAtlas';
import { Mobile32PaintedWallAtlas } from './Mobile32PaintedWallAtlas';
import { Mobile33WinterNightAtlas } from './Mobile33WinterNightAtlas';
import { Mobile33WonterNightAtlas } from './Mobile33WonterNightAtlas';
import { Mobile34ChristmasTreeAtlas } from './Mobile34ChristmasTreeAtlas';
import { Mobile35WinterHouseAtlas } from './Mobile35WinterHouseAtlas';
import { Mobile36ChristmasWallAtlas } from './Mobile36ChristmasWallAtlas';
import { Mobile37HeartRosesAtlas } from './Mobile37HeartRosesAtlas';
import { Mobile38HeartDogsAtlas } from './Mobile38HeartDogsAtlas';
import { Mobile39FieldAtlas } from './Mobile39FieldAtlas';
import { Mobile3RedAtlas } from './Mobile3RedAtlas';
import { Mobile40MountainsLakeAtlas } from './Mobile40MountainsLakeAtlas';
import { Mobile41NightSkyAtlas } from './Mobile41NightSkyAtlas';
import { Mobile42NationalParkAtlas } from './Mobile42NationalParkAtlas';
import { Mobile43SakuraAtlas } from './Mobile43SakuraAtlas';
import { Mobile44BridgeAtlas } from './Mobile44BridgeAtlas';
import { Mobile45HalloweenSkyAtlas } from './Mobile45HalloweenSkyAtlas';
import { Mobile46AutumnAtlas } from './Mobile46AutumnAtlas';
import { Mobile47HalloweenFogAtlas } from './Mobile47HalloweenFogAtlas';
import { Mobile48HalloweenPumpkinAtlas } from './Mobile48HalloweenPumpkinAtlas';
import { Mobile49LeavesAtlas } from './Mobile49LeavesAtlas';
import { Mobile4OrangeAtlas } from './Mobile4OrangeAtlas';
import { Mobile50HalloweenStillLifeAtlas } from './Mobile50HalloweenStillLifeAtlas';
import { Mobile5OliveAtlas } from './Mobile5OliveAtlas';
import { Mobile6TurquoiseAtlas } from './Mobile6TurquoiseAtlas';
import { Mobile7BurgundyAtlas } from './Mobile7BurgundyAtlas';
import { Mobile8DarkPurpleAtlas } from './Mobile8DarkPurpleAtlas';
import { Mobile9PurpleAtlas } from './Mobile9PurpleAtlas';
import { ParticlesAtlas } from './ParticlesAtlas';
import { PlaceholdersAtlas } from './PlaceholdersAtlas';
import { Tablet10DarkGreenAtlas } from './Tablet10DarkGreenAtlas';
import { Tablet11PoppiesAtlas } from './Tablet11PoppiesAtlas';
import { Tablet12GreenFieldAtlas } from './Tablet12GreenFieldAtlas';
import { Tablet13WaterfallAtlas } from './Tablet13WaterfallAtlas';
import { Tablet14BeachAtlas } from './Tablet14BeachAtlas';
import { Tablet15TurquoiseSkiesAtlas } from './Tablet15TurquoiseSkiesAtlas';
import { Tablet1GreenAtlas } from './Tablet1GreenAtlas';
import { Tablet20WoodAtlas } from './Tablet20WoodAtlas';
import { Tablet21PeonyAtlas } from './Tablet21PeonyAtlas';
import { Tablet22LonelyMountainAtlas } from './Tablet22LonelyMountainAtlas';
import { Tablet23FiveCatsAtlas } from './Tablet23FiveCatsAtlas';
import { Tablet24RoadAtlas } from './Tablet24RoadAtlas';
import { Tablet25NewYorkAtlas } from './Tablet25NewYorkAtlas';
import { Tablet26BlossomAtlas } from './Tablet26BlossomAtlas';
import { Tablet27CloudsAtlas } from './Tablet27CloudsAtlas';
import { Tablet28MountainLakeAtlas } from './Tablet28MountainLakeAtlas';
import { Tablet2BlueAtlas } from './Tablet2BlueAtlas';
import { Tablet30KittensAtlas } from './Tablet30KittensAtlas';
import { Tablet31MountainsAtlas } from './Tablet31MountainsAtlas';
import { Tablet32PaintedWallAtlas } from './Tablet32PaintedWallAtlas';
import { Tablet33WinterNightAtlas } from './Tablet33WinterNightAtlas';
import { Tablet34ChristmasTreeAtlas } from './Tablet34ChristmasTreeAtlas';
import { Tablet35WinterHouseAtlas } from './Tablet35WinterHouseAtlas';
import { Tablet36ChristmasWallAtlas } from './Tablet36ChristmasWallAtlas';
import { Tablet37HeartRosesAtlas } from './Tablet37HeartRosesAtlas';
import { Tablet38HeartDogsAtlas } from './Tablet38HeartDogsAtlas';
import { Tablet39FieldAtlas } from './Tablet39FieldAtlas';
import { Tablet3RedAtlas } from './Tablet3RedAtlas';
import { Tablet40MountainsLakeAtlas } from './Tablet40MountainsLakeAtlas';
import { Tablet41NightSkyAtlas } from './Tablet41NightSkyAtlas';
import { Tablet42NationalParkAtlas } from './Tablet42NationalParkAtlas';
import { Tablet43SakuraAtlas } from './Tablet43SakuraAtlas';
import { Tablet44BridgeAtlas } from './Tablet44BridgeAtlas';
import { Tablet45HalloweenSkyAtlas } from './Tablet45HalloweenSkyAtlas';
import { Tablet46AutumnAtlas } from './Tablet46AutumnAtlas';
import { Tablet47HalloweenFogAtlas } from './Tablet47HalloweenFogAtlas';
import { Tablet48HalloweenPumpkinAtlas } from './Tablet48HalloweenPumpkinAtlas';
import { Tablet49LeavesAtlas } from './Tablet49LeavesAtlas';
import { Tablet4OrangeAtlas } from './Tablet4OrangeAtlas';
import { Tablet50HalloweenStillLifeAtlas } from './Tablet50HalloweenStillLifeAtlas';
import { Tablet5OliveAtlas } from './Tablet5OliveAtlas';
import { Tablet6TurquoiseAtlas } from './Tablet6TurquoiseAtlas';
import { Tablet7BurgundyAtlas } from './Tablet7BurgundyAtlas';
import { Tablet8DarkPurpleAtlas } from './Tablet8DarkPurpleAtlas';
import { Tablet9PurpleAtlas } from './Tablet9PurpleAtlas';

/**
 * Enum of all available atlases
 * Auto-generated from folders in assets/packed/
 */
export enum AtlasName {
    Cardglow = 'spritesheets/cardGlow/cardGlow/cardGlow',
    CardsBacks10CardBackCatCrown = 'spritesheets/cards/backs/10_card_back_cat_crown/10_card_back_cat_crown/10_card_back_cat_crown',
    CardsBacks11CardBackCatGlasses = 'spritesheets/cards/backs/11_card_back_cat_glasses/11_card_back_cat_glasses/11_card_back_cat_glasses',
    CardsBacks12CardBackMonarchDog = 'spritesheets/cards/backs/12_card_back_monarch_dog/12_card_back_monarch_dog/12_card_back_monarch_dog',
    CardsBacks13CardBackHappyCartoonDog = 'spritesheets/cards/backs/13_card_back_happy_cartoon_dog/13_card_back_happy_cartoon_dog/13_card_back_happy_cartoon_dog',
    CardsBacks14CardBackWhitePuppy = 'spritesheets/cards/backs/14_card_back_white_puppy/14_card_back_white_puppy/14_card_back_white_puppy',
    CardsBacks15CardBackIsland = 'spritesheets/cards/backs/15_card_back_island/15_card_back_island/15_card_back_island',
    CardsBacks16CardBackCrownedDog = 'spritesheets/cards/backs/16_card_back_crowned_dog/16_card_back_crowned_dog/16_card_back_crowned_dog',
    CardsBacks17CardBackRoses = 'spritesheets/cards/backs/17_card_back_roses/17_card_back_roses/17_card_back_roses',
    CardsBacks18CardBackSunflowers = 'spritesheets/cards/backs/18_card_back_sunflowers/18_card_back_sunflowers/18_card_back_sunflowers',
    CardsBacks19CardBackRosehip = 'spritesheets/cards/backs/19_card_back_rosehip/19_card_back_rosehip/19_card_back_rosehip',
    CardsBacks1CardBackBlue = 'spritesheets/cards/backs/1_card_back_blue/1_card_back_blue/1_card_back_blue',
    CardsBacks20CardBackFloralPrint = 'spritesheets/cards/backs/20_card_back_floral_print/20_card_back_floral_print/20_card_back_floral_print',
    CardsBacks21CardBackOrchids = 'spritesheets/cards/backs/21_card_back_orchids/21_card_back_orchids/21_card_back_orchids',
    CardsBacks22CardBackSakura = 'spritesheets/cards/backs/22_card_back_sakura/22_card_back_sakura/22_card_back_sakura',
    CardsBacks23CardBackBee = 'spritesheets/cards/backs/23_card_back_bee/23_card_back_bee/23_card_back_bee',
    CardsBacks24CardBackButterfly = 'spritesheets/cards/backs/24_card_back_butterfly/24_card_back_butterfly/24_card_back_butterfly',
    CardsBacks25CardBackLadybug = 'spritesheets/cards/backs/25_card_back_ladybug/25_card_back_ladybug/25_card_back_ladybug',
    CardsBacks26CardBackCalibri = 'spritesheets/cards/backs/26_card_back_calibri/26_card_back_calibri/26_card_back_calibri',
    CardsBacks27CardBackOwl = 'spritesheets/cards/backs/27_card_back_owl/27_card_back_owl/27_card_back_owl',
    CardsBacks28CardBackToucan = 'spritesheets/cards/backs/28_card_back_toucan/28_card_back_toucan/28_card_back_toucan',
    CardsBacks29CardBackSwan = 'spritesheets/cards/backs/29_card_back_swan/29_card_back_swan/29_card_back_swan',
    CardsBacks2CardBackBlueDark = 'spritesheets/cards/backs/2_card_back_blue_dark/2_card_back_blue_dark/2_card_back_blue_dark',
    CardsBacks30CardBackBambooBear = 'spritesheets/cards/backs/30_card_back_bamboo_bear/30_card_back_bamboo_bear/30_card_back_bamboo_bear',
    CardsBacks31CardBackLeopard = 'spritesheets/cards/backs/31_card_back_leopard/31_card_back_leopard/31_card_back_leopard',
    CardsBacks32CardBackLion = 'spritesheets/cards/backs/32_card_back_lion/32_card_back_lion/32_card_back_lion',
    CardsBacks33CardBackDeer = 'spritesheets/cards/backs/33_card_back_deer/33_card_back_deer/33_card_back_deer',
    CardsBacks34CardBackPolarBear = 'spritesheets/cards/backs/34_card_back_polar_bear/34_card_back_polar_bear/34_card_back_polar_bear',
    CardsBacks35CardBackPagoda = 'spritesheets/cards/backs/35_card_back_pagoda/35_card_back_pagoda/35_card_back_pagoda',
    CardsBacks36CardBackYorkshireTerrier = 'spritesheets/cards/backs/36_card_back_yorkshire_terrier/36_card_back_yorkshire_terrier/36_card_back_yorkshire_terrier',
    CardsBacks37CardBackJapaneseScenery = 'spritesheets/cards/backs/37_card_back_japanese_scenery/37_card_back_japanese_scenery/37_card_back_japanese_scenery',
    CardsBacks38CardBackMuseum = 'spritesheets/cards/backs/38_card_back_museum/38_card_back_museum/38_card_back_museum',
    CardsBacks39CardBackPalace = 'spritesheets/cards/backs/39_card_back_palace/39_card_back_palace/39_card_back_palace',
    CardsBacks3CardBackRed = 'spritesheets/cards/backs/3_card_back_red/3_card_back_red/3_card_back_red',
    CardsBacks40CardBackCastle = 'spritesheets/cards/backs/40_card_back_castle/40_card_back_castle/40_card_back_castle',
    CardsBacks41CardBackWhiteDome = 'spritesheets/cards/backs/41_card_back_white_dome/41_card_back_white_dome/41_card_back_white_dome',
    CardsBacks42CardBackEiffelTower = 'spritesheets/cards/backs/42_card_back_eiffel_tower/42_card_back_eiffel_tower/42_card_back_eiffel_tower',
    CardsBacks43CardBackHydrangeas = 'spritesheets/cards/backs/43_card_back_hydrangeas/43_card_back_hydrangeas/43_card_back_hydrangeas',
    CardsBacks44CardBackChineseWall = 'spritesheets/cards/backs/44_card_back_chinese_wall/44_card_back_chinese_wall/44_card_back_chinese_wall',
    CardsBacks45CardBackAstrology = 'spritesheets/cards/backs/45_card_back_astrology/45_card_back_astrology/45_card_back_astrology',
    CardsBacks46CardBackSky = 'spritesheets/cards/backs/46_card_back_sky/46_card_back_sky/46_card_back_sky',
    CardsBacks47CardBackShells = 'spritesheets/cards/backs/47_card_back_shells/47_card_back_shells/47_card_back_shells',
    CardsBacks48CardBackYacht = 'spritesheets/cards/backs/48_card_back_yacht/48_card_back_yacht/48_card_back_yacht',
    CardsBacks49CardBackPirateShip = 'spritesheets/cards/backs/49_card_back_pirate_ship/49_card_back_pirate_ship/49_card_back_pirate_ship',
    CardsBacks4CardBackRedPattern = 'spritesheets/cards/backs/4_card_back_red_pattern/4_card_back_red_pattern/4_card_back_red_pattern',
    CardsBacks50CardBackCarSunset = 'spritesheets/cards/backs/50_card_back_car_sunset/50_card_back_car_sunset/50_card_back_car_sunset',
    CardsBacks51CardBackRetroCar = 'spritesheets/cards/backs/51_card_back_retro_car/51_card_back_retro_car/51_card_back_retro_car',
    CardsBacks52CardBackAstronaut = 'spritesheets/cards/backs/52_card_back_astronaut/52_card_back_astronaut/52_card_back_astronaut',
    CardsBacks53CardBackCartoonHatCat = 'spritesheets/cards/backs/53_card_back_cartoon_hat_cat/53_card_back_cartoon_hat_cat/53_card_back_cartoon_hat_cat',
    CardsBacks54CardBackFlowerGirl = 'spritesheets/cards/backs/54_card_back_flower_girl/54_card_back_flower_girl/54_card_back_flower_girl',
    CardsBacks55CardBackCandy = 'spritesheets/cards/backs/55_card_back_candy/55_card_back_candy/55_card_back_candy',
    CardsBacks56CardBackPorsche = 'spritesheets/cards/backs/56_card_back_porsche/56_card_back_porsche/56_card_back_porsche',
    CardsBacks57CardBackUmbrellas = 'spritesheets/cards/backs/57_card_back_umbrellas/57_card_back_umbrellas/57_card_back_umbrellas',
    CardsBacks58CardBackChineseLantern = 'spritesheets/cards/backs/58_card_back_chinese_lantern/58_card_back_chinese_lantern/58_card_back_chinese_lantern',
    CardsBacks59CardBackGoldenCrown = 'spritesheets/cards/backs/59_card_back_golden_crown/59_card_back_golden_crown/59_card_back_golden_crown',
    CardsBacks5CardBackBluePattern = 'spritesheets/cards/backs/5_card_back_blue_pattern/5_card_back_blue_pattern/5_card_back_blue_pattern',
    CardsBacks60CardBackPurpleCrown = 'spritesheets/cards/backs/60_card_back_purple_crown/60_card_back_purple_crown/60_card_back_purple_crown',
    CardsBacks61CardBackChinesePalace = 'spritesheets/cards/backs/61_card_back_chinese_palace/61_card_back_chinese_palace/61_card_back_chinese_palace',
    CardsBacks62CardBackGift = 'spritesheets/cards/backs/62_card_back_gift/62_card_back_gift/62_card_back_gift',
    CardsBacks63CardBackWinterDog = 'spritesheets/cards/backs/63_card_back_winter_dog/63_card_back_winter_dog/63_card_back_winter_dog',
    CardsBacks64CardBackSnowflakes = 'spritesheets/cards/backs/64_card_back_snowflakes/64_card_back_snowflakes/64_card_back_snowflakes',
    CardsBacks65CardBackGoldenBird = 'spritesheets/cards/backs/65_card_back_golden_bird/65_card_back_golden_bird/65_card_back_golden_bird',
    CardsBacks66CardBackSpider = 'spritesheets/cards/backs/66_card_back_spider/66_card_back_spider/66_card_back_spider',
    CardsBacks67CardBackHeartFlowers = 'spritesheets/cards/backs/67_card_back_heart_flowers/67_card_back_heart_flowers/67_card_back_heart_flowers',
    CardsBacks68CardBackHeartCat = 'spritesheets/cards/backs/68_card_back_heart_cat/68_card_back_heart_cat/68_card_back_heart_cat',
    CardsBacks69CardBackHeartGlasses = 'spritesheets/cards/backs/69_card_back_heart_glasses/69_card_back_heart_glasses/69_card_back_heart_glasses',
    CardsBacks6CardBackOrange = 'spritesheets/cards/backs/6_card_back_orange/6_card_back_orange/6_card_back_orange',
    CardsBacks70CardBackHeartDog = 'spritesheets/cards/backs/70_card_back_heart_dog/70_card_back_heart_dog/70_card_back_heart_dog',
    CardsBacks71CardBackClassicBlue = 'spritesheets/cards/backs/71_card_back_classic_blue/71_card_back_classic_blue/71_card_back_classic_blue',
    CardsBacks72CardBackClassicPurple = 'spritesheets/cards/backs/72_card_back_classic_purple/72_card_back_classic_purple/72_card_back_classic_purple',
    CardsBacks73CardBackClassicRed = 'spritesheets/cards/backs/73_card_back_classic_red/73_card_back_classic_red/73_card_back_classic_red',
    CardsBacks74CardBackPanda = 'spritesheets/cards/backs/74_card_back_panda/74_card_back_panda/74_card_back_panda',
    CardsBacks75CardBackPandaLeaves = 'spritesheets/cards/backs/75_card_back_panda_leaves/75_card_back_panda_leaves/75_card_back_panda_leaves',
    CardsBacks76CardBackPalace = 'spritesheets/cards/backs/76_card_back_palace/76_card_back_palace/76_card_back_palace',
    CardsBacks77CardBackHalloween = 'spritesheets/cards/backs/77_card_back_halloween/77_card_back_halloween/77_card_back_halloween',
    CardsBacks78CardBackAutumn = 'spritesheets/cards/backs/78_card_back_autumn/78_card_back_autumn/78_card_back_autumn',
    CardsBacks79CardBackHalloweenCastle = 'spritesheets/cards/backs/79_card_back_halloween_castle/79_card_back_halloween_castle/79_card_back_halloween_castle',
    CardsBacks7CardBackGingerKitten = 'spritesheets/cards/backs/7_card_back_ginger_kitten/7_card_back_ginger_kitten/7_card_back_ginger_kitten',
    CardsBacks80CardBackHalloweenPumpkin = 'spritesheets/cards/backs/80_card_back_halloween_pumpkin/80_card_back_halloween_pumpkin/80_card_back_halloween_pumpkin',
    CardsBacks81CardBackHalloweenMoon = 'spritesheets/cards/backs/81_card_back_halloween_moon/81_card_back_halloween_moon/81_card_back_halloween_moon',
    CardsBacks82CardBackHalloweenMushroom = 'spritesheets/cards/backs/82_card_back_halloween_mushroom/82_card_back_halloween_mushroom/82_card_back_halloween_mushroom',
    CardsBacks8CardBackCatHead = 'spritesheets/cards/backs/8_card_back_cat_head/8_card_back_cat_head/8_card_back_cat_head',
    CardsBacks9CardBackChineseCat = 'spritesheets/cards/backs/9_card_back_chinese_cat/9_card_back_chinese_cat/9_card_back_chinese_cat',
    CardsFront10Cartoonish0 = 'spritesheets/cards/front/10_cartoonish-0/10_cartoonish-0/10_cartoonish-0',
    CardsFront10Cartoonish1 = 'spritesheets/cards/front/10_cartoonish-1/10_cartoonish-1/10_cartoonish-1',
    CardsFront10Cartoonish2 = 'spritesheets/cards/front/10_cartoonish-2/10_cartoonish-2/10_cartoonish-2',
    CardsFront10Cartoonish3 = 'spritesheets/cards/front/10_cartoonish-3/10_cartoonish-3/10_cartoonish-3',
    CardsFront10Cartoonish4 = 'spritesheets/cards/front/10_cartoonish-4/10_cartoonish-4/10_cartoonish-4',
    CardsFront10Cartoonish5 = 'spritesheets/cards/front/10_cartoonish-5/10_cartoonish-5/10_cartoonish-5',
    CardsFront10Cartoonish6 = 'spritesheets/cards/front/10_cartoonish-6/10_cartoonish-6/10_cartoonish-6',
    CardsFront10Cartoonish7 = 'spritesheets/cards/front/10_cartoonish-7/10_cartoonish-7/10_cartoonish-7',
    CardsFront10Cartoonish8 = 'spritesheets/cards/front/10_cartoonish-8/10_cartoonish-8/10_cartoonish-8',
    CardsFront11WhiteLarge0 = 'spritesheets/cards/front/11_white_large-0/11_white_large-0/11_white_large-0',
    CardsFront11WhiteLarge1 = 'spritesheets/cards/front/11_white_large-1/11_white_large-1/11_white_large-1',
    CardsFront11WhiteLarge2 = 'spritesheets/cards/front/11_white_large-2/11_white_large-2/11_white_large-2',
    CardsFront11WhiteLarge3 = 'spritesheets/cards/front/11_white_large-3/11_white_large-3/11_white_large-3',
    CardsFront11WhiteLarge4 = 'spritesheets/cards/front/11_white_large-4/11_white_large-4/11_white_large-4',
    CardsFront12ClassicLarge0 = 'spritesheets/cards/front/12_classic_large-0/12_classic_large-0/12_classic_large-0',
    CardsFront12ClassicLarge1 = 'spritesheets/cards/front/12_classic_large-1/12_classic_large-1/12_classic_large-1',
    CardsFront12ClassicLarge2 = 'spritesheets/cards/front/12_classic_large-2/12_classic_large-2/12_classic_large-2',
    CardsFront12ClassicLarge3 = 'spritesheets/cards/front/12_classic_large-3/12_classic_large-3/12_classic_large-3',
    CardsFront12ClassicLarge4 = 'spritesheets/cards/front/12_classic_large-4/12_classic_large-4/12_classic_large-4',
    CardsFront13Classic0 = 'spritesheets/cards/front/13_classic-0/13_classic-0/13_classic-0',
    CardsFront13Classic1 = 'spritesheets/cards/front/13_classic-1/13_classic-1/13_classic-1',
    CardsFront13Classic2 = 'spritesheets/cards/front/13_classic-2/13_classic-2/13_classic-2',
    CardsFront13Classic3 = 'spritesheets/cards/front/13_classic-3/13_classic-3/13_classic-3',
    CardsFront13Classic4 = 'spritesheets/cards/front/13_classic-4/13_classic-4/13_classic-4',
    CardsFront1White0 = 'spritesheets/cards/front/1_white-0/1_white-0/1_white-0',
    CardsFront1White1 = 'spritesheets/cards/front/1_white-1/1_white-1/1_white-1',
    CardsFront1White2 = 'spritesheets/cards/front/1_white-2/1_white-2/1_white-2',
    CardsFront1White3 = 'spritesheets/cards/front/1_white-3/1_white-3/1_white-3',
    CardsFront1White4 = 'spritesheets/cards/front/1_white-4/1_white-4/1_white-4',
    CardsFront1White5 = 'spritesheets/cards/front/1_white-5/1_white-5/1_white-5',
    CardsFront1White6 = 'spritesheets/cards/front/1_white-6/1_white-6/1_white-6',
    CardsFront1White7 = 'spritesheets/cards/front/1_white-7/1_white-7/1_white-7',
    CardsFront1White8 = 'spritesheets/cards/front/1_white-8/1_white-8/1_white-8',
    CardsFront2Ivory0 = 'spritesheets/cards/front/2_ivory-0/2_ivory-0/2_ivory-0',
    CardsFront2Ivory1 = 'spritesheets/cards/front/2_ivory-1/2_ivory-1/2_ivory-1',
    CardsFront2Ivory2 = 'spritesheets/cards/front/2_ivory-2/2_ivory-2/2_ivory-2',
    CardsFront2Ivory3 = 'spritesheets/cards/front/2_ivory-3/2_ivory-3/2_ivory-3',
    CardsFront2Ivory4 = 'spritesheets/cards/front/2_ivory-4/2_ivory-4/2_ivory-4',
    CardsFront2Ivory5 = 'spritesheets/cards/front/2_ivory-5/2_ivory-5/2_ivory-5',
    CardsFront2Ivory6 = 'spritesheets/cards/front/2_ivory-6/2_ivory-6/2_ivory-6',
    CardsFront2Ivory7 = 'spritesheets/cards/front/2_ivory-7/2_ivory-7/2_ivory-7',
    CardsFront2Ivory8 = 'spritesheets/cards/front/2_ivory-8/2_ivory-8/2_ivory-8',
    CardsFront3Medieval0 = 'spritesheets/cards/front/3_medieval-0/3_medieval-0/3_medieval-0',
    CardsFront3Medieval1 = 'spritesheets/cards/front/3_medieval-1/3_medieval-1/3_medieval-1',
    CardsFront3Medieval2 = 'spritesheets/cards/front/3_medieval-2/3_medieval-2/3_medieval-2',
    CardsFront3Medieval3 = 'spritesheets/cards/front/3_medieval-3/3_medieval-3/3_medieval-3',
    CardsFront3Medieval4 = 'spritesheets/cards/front/3_medieval-4/3_medieval-4/3_medieval-4',
    CardsFront3Medieval5 = 'spritesheets/cards/front/3_medieval-5/3_medieval-5/3_medieval-5',
    CardsFront3Medieval6 = 'spritesheets/cards/front/3_medieval-6/3_medieval-6/3_medieval-6',
    CardsFront3Medieval7 = 'spritesheets/cards/front/3_medieval-7/3_medieval-7/3_medieval-7',
    CardsFront3Medieval8 = 'spritesheets/cards/front/3_medieval-8/3_medieval-8/3_medieval-8',
    CardsFront4Gothic0 = 'spritesheets/cards/front/4_gothic-0/4_gothic-0/4_gothic-0',
    CardsFront4Gothic1 = 'spritesheets/cards/front/4_gothic-1/4_gothic-1/4_gothic-1',
    CardsFront4Gothic2 = 'spritesheets/cards/front/4_gothic-2/4_gothic-2/4_gothic-2',
    CardsFront4Gothic3 = 'spritesheets/cards/front/4_gothic-3/4_gothic-3/4_gothic-3',
    CardsFront4Gothic4 = 'spritesheets/cards/front/4_gothic-4/4_gothic-4/4_gothic-4',
    CardsFront4Gothic5 = 'spritesheets/cards/front/4_gothic-5/4_gothic-5/4_gothic-5',
    CardsFront4Gothic6 = 'spritesheets/cards/front/4_gothic-6/4_gothic-6/4_gothic-6',
    CardsFront4Gothic7 = 'spritesheets/cards/front/4_gothic-7/4_gothic-7/4_gothic-7',
    CardsFront4Gothic8 = 'spritesheets/cards/front/4_gothic-8/4_gothic-8/4_gothic-8',
    CardsFront5Cats0 = 'spritesheets/cards/front/5_cats-0/5_cats-0/5_cats-0',
    CardsFront5Cats1 = 'spritesheets/cards/front/5_cats-1/5_cats-1/5_cats-1',
    CardsFront5Cats2 = 'spritesheets/cards/front/5_cats-2/5_cats-2/5_cats-2',
    CardsFront5Cats3 = 'spritesheets/cards/front/5_cats-3/5_cats-3/5_cats-3',
    CardsFront5Cats4 = 'spritesheets/cards/front/5_cats-4/5_cats-4/5_cats-4',
    CardsFront5Cats5 = 'spritesheets/cards/front/5_cats-5/5_cats-5/5_cats-5',
    CardsFront5Cats6 = 'spritesheets/cards/front/5_cats-6/5_cats-6/5_cats-6',
    CardsFront5Cats7 = 'spritesheets/cards/front/5_cats-7/5_cats-7/5_cats-7',
    CardsFront5Cats8 = 'spritesheets/cards/front/5_cats-8/5_cats-8/5_cats-8',
    CardsFront6Dogs0 = 'spritesheets/cards/front/6_dogs-0/6_dogs-0/6_dogs-0',
    CardsFront6Dogs1 = 'spritesheets/cards/front/6_dogs-1/6_dogs-1/6_dogs-1',
    CardsFront6Dogs2 = 'spritesheets/cards/front/6_dogs-2/6_dogs-2/6_dogs-2',
    CardsFront6Dogs3 = 'spritesheets/cards/front/6_dogs-3/6_dogs-3/6_dogs-3',
    CardsFront6Dogs4 = 'spritesheets/cards/front/6_dogs-4/6_dogs-4/6_dogs-4',
    CardsFront6Dogs5 = 'spritesheets/cards/front/6_dogs-5/6_dogs-5/6_dogs-5',
    CardsFront6Dogs6 = 'spritesheets/cards/front/6_dogs-6/6_dogs-6/6_dogs-6',
    CardsFront6Dogs7 = 'spritesheets/cards/front/6_dogs-7/6_dogs-7/6_dogs-7',
    CardsFront6Dogs8 = 'spritesheets/cards/front/6_dogs-8/6_dogs-8/6_dogs-8',
    CardsFront7Elegant0 = 'spritesheets/cards/front/7_elegant-0/7_elegant-0/7_elegant-0',
    CardsFront7Elegant1 = 'spritesheets/cards/front/7_elegant-1/7_elegant-1/7_elegant-1',
    CardsFront7Elegant2 = 'spritesheets/cards/front/7_elegant-2/7_elegant-2/7_elegant-2',
    CardsFront7Elegant3 = 'spritesheets/cards/front/7_elegant-3/7_elegant-3/7_elegant-3',
    CardsFront7Elegant4 = 'spritesheets/cards/front/7_elegant-4/7_elegant-4/7_elegant-4',
    CardsFront7Elegant5 = 'spritesheets/cards/front/7_elegant-5/7_elegant-5/7_elegant-5',
    CardsFront7Elegant6 = 'spritesheets/cards/front/7_elegant-6/7_elegant-6/7_elegant-6',
    CardsFront7Elegant7 = 'spritesheets/cards/front/7_elegant-7/7_elegant-7/7_elegant-7',
    CardsFront7Elegant8 = 'spritesheets/cards/front/7_elegant-8/7_elegant-8/7_elegant-8',
    CardsFront8Neon0 = 'spritesheets/cards/front/8_neon-0/8_neon-0/8_neon-0',
    CardsFront8Neon1 = 'spritesheets/cards/front/8_neon-1/8_neon-1/8_neon-1',
    CardsFront8Neon2 = 'spritesheets/cards/front/8_neon-2/8_neon-2/8_neon-2',
    CardsFront8Neon3 = 'spritesheets/cards/front/8_neon-3/8_neon-3/8_neon-3',
    CardsFront8Neon4 = 'spritesheets/cards/front/8_neon-4/8_neon-4/8_neon-4',
    CardsFront8Neon5 = 'spritesheets/cards/front/8_neon-5/8_neon-5/8_neon-5',
    CardsFront8Neon6 = 'spritesheets/cards/front/8_neon-6/8_neon-6/8_neon-6',
    CardsFront8Neon7 = 'spritesheets/cards/front/8_neon-7/8_neon-7/8_neon-7',
    CardsFront8Neon8 = 'spritesheets/cards/front/8_neon-8/8_neon-8/8_neon-8',
    CardsFront9Retro0 = 'spritesheets/cards/front/9_retro-0/9_retro-0/9_retro-0',
    CardsFront9Retro1 = 'spritesheets/cards/front/9_retro-1/9_retro-1/9_retro-1',
    CardsFront9Retro2 = 'spritesheets/cards/front/9_retro-2/9_retro-2/9_retro-2',
    CardsFront9Retro3 = 'spritesheets/cards/front/9_retro-3/9_retro-3/9_retro-3',
    CardsFront9Retro4 = 'spritesheets/cards/front/9_retro-4/9_retro-4/9_retro-4',
    CardsFront9Retro5 = 'spritesheets/cards/front/9_retro-5/9_retro-5/9_retro-5',
    CardsFront9Retro6 = 'spritesheets/cards/front/9_retro-6/9_retro-6/9_retro-6',
    CardsFront9Retro7 = 'spritesheets/cards/front/9_retro-7/9_retro-7/9_retro-7',
    CardsFront9Retro8 = 'spritesheets/cards/front/9_retro-8/9_retro-8/9_retro-8',
    CardsShadow = 'spritesheets/cards/shadow/shadow',
    Desktop10DarkGreen = 'backgroundsSpritesheets/desktop/10_dark_green/10_dark_green/10_dark_green',
    Desktop11Poppies = 'backgroundsSpritesheets/desktop/11_poppies/11_poppies/11_poppies',
    Desktop12GreenField = 'backgroundsSpritesheets/desktop/12_green_field/12_green_field/12_green_field',
    Desktop13Waterfall = 'backgroundsSpritesheets/desktop/13_waterfall/13_waterfall/13_waterfall',
    Desktop14Beach = 'backgroundsSpritesheets/desktop/14_beach/14_beach/14_beach',
    Desktop15TurquoiseSkies = 'backgroundsSpritesheets/desktop/15_turquoise_skies/15_turquoise_skies/15_turquoise_skies',
    Desktop1Green = 'backgroundsSpritesheets/desktop/1_green/1_green/1_green',
    Desktop20Wood = 'backgroundsSpritesheets/desktop/20_wood/20_wood/20_wood',
    Desktop21Peony = 'backgroundsSpritesheets/desktop/21_peony/21_peony/21_peony',
    Desktop22LonelyMountain = 'backgroundsSpritesheets/desktop/22_lonely_mountain/22_lonely_mountain/22_lonely_mountain',
    Desktop23FiveCats = 'backgroundsSpritesheets/desktop/23_five_cats/23_five_cats/23_five_cats',
    Desktop24Road = 'backgroundsSpritesheets/desktop/24_road/24_road/24_road',
    Desktop25NewYork = 'backgroundsSpritesheets/desktop/25_new_york/25_new_york/25_new_york',
    Desktop26Blossom = 'backgroundsSpritesheets/desktop/26_blossom/26_blossom/26_blossom',
    Desktop27Clouds = 'backgroundsSpritesheets/desktop/27_clouds/27_clouds/27_clouds',
    Desktop28MountainLake = 'backgroundsSpritesheets/desktop/28_mountain_lake/28_mountain_lake/28_mountain_lake',
    Desktop2Blue = 'backgroundsSpritesheets/desktop/2_blue/2_blue/2_blue',
    Desktop30Kittens = 'backgroundsSpritesheets/desktop/30_kittens/30_kittens/30_kittens',
    Desktop31Mountains = 'backgroundsSpritesheets/desktop/31_mountains/31_mountains/31_mountains',
    Desktop32PaintedWall = 'backgroundsSpritesheets/desktop/32_painted_wall/32_painted_wall/32_painted_wall',
    Desktop33WinterNight = 'backgroundsSpritesheets/desktop/33_winter_night/33_winter_night/33_winter_night',
    Desktop34ChristmasTree = 'backgroundsSpritesheets/desktop/34_christmas_tree/34_christmas_tree/34_christmas_tree',
    Desktop35WinterHouse = 'backgroundsSpritesheets/desktop/35_winter_house/35_winter_house/35_winter_house',
    Desktop36ChristmasWall = 'backgroundsSpritesheets/desktop/36_christmas_wall/36_christmas_wall/36_christmas_wall',
    Desktop37HeartRoses = 'backgroundsSpritesheets/desktop/37_heart_roses/37_heart_roses/37_heart_roses',
    Desktop38HeartDogs = 'backgroundsSpritesheets/desktop/38_heart_dogs/38_heart_dogs/38_heart_dogs',
    Desktop39Field = 'backgroundsSpritesheets/desktop/39_field/39_field/39_field',
    Desktop3Red = 'backgroundsSpritesheets/desktop/3_red/3_red/3_red',
    Desktop40MountainsLake = 'backgroundsSpritesheets/desktop/40_mountains_lake/40_mountains_lake/40_mountains_lake',
    Desktop41NightSky = 'backgroundsSpritesheets/desktop/41_night_sky/41_night_sky/41_night_sky',
    Desktop42NationalPark = 'backgroundsSpritesheets/desktop/42_national_park/42_national_park/42_national_park',
    Desktop43Sakura = 'backgroundsSpritesheets/desktop/43_sakura/43_sakura/43_sakura',
    Desktop44Bridge = 'backgroundsSpritesheets/desktop/44_bridge/44_bridge/44_bridge',
    Desktop45HalloweenSky = 'backgroundsSpritesheets/desktop/45_halloween_sky/45_halloween_sky/45_halloween_sky',
    Desktop46Autumn = 'backgroundsSpritesheets/desktop/46_autumn/46_autumn/46_autumn',
    Desktop47HalloweenFog = 'backgroundsSpritesheets/desktop/47_halloween_fog/47_halloween_fog/47_halloween_fog',
    Desktop48HalloweenPumpkin = 'backgroundsSpritesheets/desktop/48_halloween_pumpkin/48_halloween_pumpkin/48_halloween_pumpkin',
    Desktop49Leaves = 'backgroundsSpritesheets/desktop/49_leaves/49_leaves/49_leaves',
    Desktop4Orange = 'backgroundsSpritesheets/desktop/4_orange/4_orange/4_orange',
    Desktop50HalloweenStillLife = 'backgroundsSpritesheets/desktop/50_halloween_still_life/50_halloween_still_life/50_halloween_still_life',
    Desktop5Olive = 'backgroundsSpritesheets/desktop/5_olive/5_olive/5_olive',
    Desktop6Turquoise = 'backgroundsSpritesheets/desktop/6_turquoise/6_turquoise/6_turquoise',
    Desktop7Burgundy = 'backgroundsSpritesheets/desktop/7_burgundy/7_burgundy/7_burgundy',
    Desktop8DarkPurple = 'backgroundsSpritesheets/desktop/8_dark_purple/8_dark_purple/8_dark_purple',
    Desktop9Purple = 'backgroundsSpritesheets/desktop/9_purple/9_purple/9_purple',
    Mobile10DarkGreen = 'backgroundsSpritesheets/mobile/10_dark_green/10_dark_green/10_dark_green',
    Mobile12GreenField = 'backgroundsSpritesheets/mobile/12_green_field/12_green_field/12_green_field',
    Mobile13Waterfall = 'backgroundsSpritesheets/mobile/13_waterfall/13_waterfall/13_waterfall',
    Mobile14Beach = 'backgroundsSpritesheets/mobile/14_beach/14_beach/14_beach',
    Mobile15TurquoiseSkies = 'backgroundsSpritesheets/mobile/15_turquoise_skies/15_turquoise_skies/15_turquoise_skies',
    Mobile1Green = 'backgroundsSpritesheets/mobile/1_green/1_green/1_green',
    Mobile20Wood = 'backgroundsSpritesheets/mobile/20_wood/20_wood/20_wood',
    Mobile21Peony = 'backgroundsSpritesheets/mobile/21_peony/21_peony/21_peony',
    Mobile22LonelyMountain = 'backgroundsSpritesheets/mobile/22_lonely_mountain/22_lonely_mountain/22_lonely_mountain',
    Mobile23FiveCats = 'backgroundsSpritesheets/mobile/23_five_cats/23_five_cats/23_five_cats',
    Mobile24Road = 'backgroundsSpritesheets/mobile/24_road/24_road/24_road',
    Mobile25NewYork = 'backgroundsSpritesheets/mobile/25_new_york/25_new_york/25_new_york',
    Mobile26Blossom = 'backgroundsSpritesheets/mobile/26_blossom/26_blossom/26_blossom',
    Mobile27Clouds = 'backgroundsSpritesheets/mobile/27_clouds/27_clouds/27_clouds',
    Mobile28MountainLake = 'backgroundsSpritesheets/mobile/28_mountain_lake/28_mountain_lake/28_mountain_lake',
    Mobile2Blue = 'backgroundsSpritesheets/mobile/2_blue/2_blue/2_blue',
    Mobile30Kittens = 'backgroundsSpritesheets/mobile/30_kittens/30_kittens/30_kittens',
    Mobile31Mountains = 'backgroundsSpritesheets/mobile/31_mountains/31_mountains/31_mountains',
    Mobile32PaintedWall = 'backgroundsSpritesheets/mobile/32_painted_wall/32_painted_wall/32_painted_wall',
    Mobile33WinterNight = 'backgroundsSpritesheets/mobile/33_winter_night/33_winter_night/33_winter_night',
    Mobile33WonterNight = 'backgroundsSpritesheets/mobile/33_wonter_night/33_wonter_night/33_wonter_night',
    Mobile34ChristmasTree = 'backgroundsSpritesheets/mobile/34_christmas_tree/34_christmas_tree/34_christmas_tree',
    Mobile35WinterHouse = 'backgroundsSpritesheets/mobile/35_winter_house/35_winter_house/35_winter_house',
    Mobile36ChristmasWall = 'backgroundsSpritesheets/mobile/36_christmas_wall/36_christmas_wall/36_christmas_wall',
    Mobile37HeartRoses = 'backgroundsSpritesheets/mobile/37_heart_roses/37_heart_roses/37_heart_roses',
    Mobile38HeartDogs = 'backgroundsSpritesheets/mobile/38_heart_dogs/38_heart_dogs/38_heart_dogs',
    Mobile39Field = 'backgroundsSpritesheets/mobile/39_field/39_field/39_field',
    Mobile3Red = 'backgroundsSpritesheets/mobile/3_red/3_red/3_red',
    Mobile40MountainsLake = 'backgroundsSpritesheets/mobile/40_mountains_lake/40_mountains_lake/40_mountains_lake',
    Mobile41NightSky = 'backgroundsSpritesheets/mobile/41_night_sky/41_night_sky/41_night_sky',
    Mobile42NationalPark = 'backgroundsSpritesheets/mobile/42_national_park/42_national_park/42_national_park',
    Mobile43Sakura = 'backgroundsSpritesheets/mobile/43_sakura/43_sakura/43_sakura',
    Mobile44Bridge = 'backgroundsSpritesheets/mobile/44_bridge/44_bridge/44_bridge',
    Mobile45HalloweenSky = 'backgroundsSpritesheets/mobile/45_halloween_sky/45_halloween_sky/45_halloween_sky',
    Mobile46Autumn = 'backgroundsSpritesheets/mobile/46_autumn/46_autumn/46_autumn',
    Mobile47HalloweenFog = 'backgroundsSpritesheets/mobile/47_halloween_fog/47_halloween_fog/47_halloween_fog',
    Mobile48HalloweenPumpkin = 'backgroundsSpritesheets/mobile/48_halloween_pumpkin/48_halloween_pumpkin/48_halloween_pumpkin',
    Mobile49Leaves = 'backgroundsSpritesheets/mobile/49_leaves/49_leaves/49_leaves',
    Mobile4Orange = 'backgroundsSpritesheets/mobile/4_orange/4_orange/4_orange',
    Mobile50HalloweenStillLife = 'backgroundsSpritesheets/mobile/50_halloween_still_life/50_halloween_still_life/50_halloween_still_life',
    Mobile5Olive = 'backgroundsSpritesheets/mobile/5_olive/5_olive/5_olive',
    Mobile6Turquoise = 'backgroundsSpritesheets/mobile/6_turquoise/6_turquoise/6_turquoise',
    Mobile7Burgundy = 'backgroundsSpritesheets/mobile/7_burgundy/7_burgundy/7_burgundy',
    Mobile8DarkPurple = 'backgroundsSpritesheets/mobile/8_dark_purple/8_dark_purple/8_dark_purple',
    Mobile9Purple = 'backgroundsSpritesheets/mobile/9_purple/9_purple/9_purple',
    Particles = 'spritesheets/particles/particles/particles',
    Placeholders = 'spritesheets/placeholders/placeholders/placeholders',
    Tablet10DarkGreen = 'backgroundsSpritesheets/tablet/10_dark_green/10_dark_green/10_dark_green',
    Tablet11Poppies = 'backgroundsSpritesheets/tablet/11_poppies/11_poppies/11_poppies',
    Tablet12GreenField = 'backgroundsSpritesheets/tablet/12_green_field/12_green_field/12_green_field',
    Tablet13Waterfall = 'backgroundsSpritesheets/tablet/13_waterfall/13_waterfall/13_waterfall',
    Tablet14Beach = 'backgroundsSpritesheets/tablet/14_beach/14_beach/14_beach',
    Tablet15TurquoiseSkies = 'backgroundsSpritesheets/tablet/15_turquoise_skies/15_turquoise_skies/15_turquoise_skies',
    Tablet1Green = 'backgroundsSpritesheets/tablet/1_green/1_green/1_green',
    Tablet20Wood = 'backgroundsSpritesheets/tablet/20_wood/20_wood/20_wood',
    Tablet21Peony = 'backgroundsSpritesheets/tablet/21_peony/21_peony/21_peony',
    Tablet22LonelyMountain = 'backgroundsSpritesheets/tablet/22_lonely_mountain/22_lonely_mountain/22_lonely_mountain',
    Tablet23FiveCats = 'backgroundsSpritesheets/tablet/23_five_cats/23_five_cats/23_five_cats',
    Tablet24Road = 'backgroundsSpritesheets/tablet/24_road/24_road/24_road',
    Tablet25NewYork = 'backgroundsSpritesheets/tablet/25_new_york/25_new_york/25_new_york',
    Tablet26Blossom = 'backgroundsSpritesheets/tablet/26_blossom/26_blossom/26_blossom',
    Tablet27Clouds = 'backgroundsSpritesheets/tablet/27_clouds/27_clouds/27_clouds',
    Tablet28MountainLake = 'backgroundsSpritesheets/tablet/28_mountain_lake/28_mountain_lake/28_mountain_lake',
    Tablet2Blue = 'backgroundsSpritesheets/tablet/2_blue/2_blue/2_blue',
    Tablet30Kittens = 'backgroundsSpritesheets/tablet/30_kittens/30_kittens/30_kittens',
    Tablet31Mountains = 'backgroundsSpritesheets/tablet/31_mountains/31_mountains/31_mountains',
    Tablet32PaintedWall = 'backgroundsSpritesheets/tablet/32_painted_wall/32_painted_wall/32_painted_wall',
    Tablet33WinterNight = 'backgroundsSpritesheets/tablet/33_winter_night/33_winter_night/33_winter_night',
    Tablet34ChristmasTree = 'backgroundsSpritesheets/tablet/34_christmas_tree/34_christmas_tree/34_christmas_tree',
    Tablet35WinterHouse = 'backgroundsSpritesheets/tablet/35_winter_house/35_winter_house/35_winter_house',
    Tablet36ChristmasWall = 'backgroundsSpritesheets/tablet/36_christmas_wall/36_christmas_wall/36_christmas_wall',
    Tablet37HeartRoses = 'backgroundsSpritesheets/tablet/37_heart_roses/37_heart_roses/37_heart_roses',
    Tablet38HeartDogs = 'backgroundsSpritesheets/tablet/38_heart_dogs/38_heart_dogs/38_heart_dogs',
    Tablet39Field = 'backgroundsSpritesheets/tablet/39_field/39_field/39_field',
    Tablet3Red = 'backgroundsSpritesheets/tablet/3_red/3_red/3_red',
    Tablet40MountainsLake = 'backgroundsSpritesheets/tablet/40_mountains_lake/40_mountains_lake/40_mountains_lake',
    Tablet41NightSky = 'backgroundsSpritesheets/tablet/41_night_sky/41_night_sky/41_night_sky',
    Tablet42NationalPark = 'backgroundsSpritesheets/tablet/42_national_park/42_national_park/42_national_park',
    Tablet43Sakura = 'backgroundsSpritesheets/tablet/43_sakura/43_sakura/43_sakura',
    Tablet44Bridge = 'backgroundsSpritesheets/tablet/44_bridge/44_bridge/44_bridge',
    Tablet45HalloweenSky = 'backgroundsSpritesheets/tablet/45_halloween_sky/45_halloween_sky/45_halloween_sky',
    Tablet46Autumn = 'backgroundsSpritesheets/tablet/46_autumn/46_autumn/46_autumn',
    Tablet47HalloweenFog = 'backgroundsSpritesheets/tablet/47_halloween_fog/47_halloween_fog/47_halloween_fog',
    Tablet48HalloweenPumpkin = 'backgroundsSpritesheets/tablet/48_halloween_pumpkin/48_halloween_pumpkin/48_halloween_pumpkin',
    Tablet49Leaves = 'backgroundsSpritesheets/tablet/49_leaves/49_leaves/49_leaves',
    Tablet4Orange = 'backgroundsSpritesheets/tablet/4_orange/4_orange/4_orange',
    Tablet50HalloweenStillLife = 'backgroundsSpritesheets/tablet/50_halloween_still_life/50_halloween_still_life/50_halloween_still_life',
    Tablet5Olive = 'backgroundsSpritesheets/tablet/5_olive/5_olive/5_olive',
    Tablet6Turquoise = 'backgroundsSpritesheets/tablet/6_turquoise/6_turquoise/6_turquoise',
    Tablet7Burgundy = 'backgroundsSpritesheets/tablet/7_burgundy/7_burgundy/7_burgundy',
    Tablet8DarkPurple = 'backgroundsSpritesheets/tablet/8_dark_purple/8_dark_purple/8_dark_purple',
    Tablet9Purple = 'backgroundsSpritesheets/tablet/9_purple/9_purple/9_purple',
}

/**
 * Registry of all available atlases
 * Automatically includes all atlases from assets/packed/
 */
export const ATLAS_REGISTRY = {
    [AtlasName.Cardglow]: CardglowAtlas,
    [AtlasName.CardsBacks10CardBackCatCrown]: CardsBacks10CardBackCatCrownAtlas,
    [AtlasName.CardsBacks11CardBackCatGlasses]: CardsBacks11CardBackCatGlassesAtlas,
    [AtlasName.CardsBacks12CardBackMonarchDog]: CardsBacks12CardBackMonarchDogAtlas,
    [AtlasName.CardsBacks13CardBackHappyCartoonDog]: CardsBacks13CardBackHappyCartoonDogAtlas,
    [AtlasName.CardsBacks14CardBackWhitePuppy]: CardsBacks14CardBackWhitePuppyAtlas,
    [AtlasName.CardsBacks15CardBackIsland]: CardsBacks15CardBackIslandAtlas,
    [AtlasName.CardsBacks16CardBackCrownedDog]: CardsBacks16CardBackCrownedDogAtlas,
    [AtlasName.CardsBacks17CardBackRoses]: CardsBacks17CardBackRosesAtlas,
    [AtlasName.CardsBacks18CardBackSunflowers]: CardsBacks18CardBackSunflowersAtlas,
    [AtlasName.CardsBacks19CardBackRosehip]: CardsBacks19CardBackRosehipAtlas,
    [AtlasName.CardsBacks1CardBackBlue]: CardsBacks1CardBackBlueAtlas,
    [AtlasName.CardsBacks20CardBackFloralPrint]: CardsBacks20CardBackFloralPrintAtlas,
    [AtlasName.CardsBacks21CardBackOrchids]: CardsBacks21CardBackOrchidsAtlas,
    [AtlasName.CardsBacks22CardBackSakura]: CardsBacks22CardBackSakuraAtlas,
    [AtlasName.CardsBacks23CardBackBee]: CardsBacks23CardBackBeeAtlas,
    [AtlasName.CardsBacks24CardBackButterfly]: CardsBacks24CardBackButterflyAtlas,
    [AtlasName.CardsBacks25CardBackLadybug]: CardsBacks25CardBackLadybugAtlas,
    [AtlasName.CardsBacks26CardBackCalibri]: CardsBacks26CardBackCalibriAtlas,
    [AtlasName.CardsBacks27CardBackOwl]: CardsBacks27CardBackOwlAtlas,
    [AtlasName.CardsBacks28CardBackToucan]: CardsBacks28CardBackToucanAtlas,
    [AtlasName.CardsBacks29CardBackSwan]: CardsBacks29CardBackSwanAtlas,
    [AtlasName.CardsBacks2CardBackBlueDark]: CardsBacks2CardBackBlueDarkAtlas,
    [AtlasName.CardsBacks30CardBackBambooBear]: CardsBacks30CardBackBambooBearAtlas,
    [AtlasName.CardsBacks31CardBackLeopard]: CardsBacks31CardBackLeopardAtlas,
    [AtlasName.CardsBacks32CardBackLion]: CardsBacks32CardBackLionAtlas,
    [AtlasName.CardsBacks33CardBackDeer]: CardsBacks33CardBackDeerAtlas,
    [AtlasName.CardsBacks34CardBackPolarBear]: CardsBacks34CardBackPolarBearAtlas,
    [AtlasName.CardsBacks35CardBackPagoda]: CardsBacks35CardBackPagodaAtlas,
    [AtlasName.CardsBacks36CardBackYorkshireTerrier]: CardsBacks36CardBackYorkshireTerrierAtlas,
    [AtlasName.CardsBacks37CardBackJapaneseScenery]: CardsBacks37CardBackJapaneseSceneryAtlas,
    [AtlasName.CardsBacks38CardBackMuseum]: CardsBacks38CardBackMuseumAtlas,
    [AtlasName.CardsBacks39CardBackPalace]: CardsBacks39CardBackPalaceAtlas,
    [AtlasName.CardsBacks3CardBackRed]: CardsBacks3CardBackRedAtlas,
    [AtlasName.CardsBacks40CardBackCastle]: CardsBacks40CardBackCastleAtlas,
    [AtlasName.CardsBacks41CardBackWhiteDome]: CardsBacks41CardBackWhiteDomeAtlas,
    [AtlasName.CardsBacks42CardBackEiffelTower]: CardsBacks42CardBackEiffelTowerAtlas,
    [AtlasName.CardsBacks43CardBackHydrangeas]: CardsBacks43CardBackHydrangeasAtlas,
    [AtlasName.CardsBacks44CardBackChineseWall]: CardsBacks44CardBackChineseWallAtlas,
    [AtlasName.CardsBacks45CardBackAstrology]: CardsBacks45CardBackAstrologyAtlas,
    [AtlasName.CardsBacks46CardBackSky]: CardsBacks46CardBackSkyAtlas,
    [AtlasName.CardsBacks47CardBackShells]: CardsBacks47CardBackShellsAtlas,
    [AtlasName.CardsBacks48CardBackYacht]: CardsBacks48CardBackYachtAtlas,
    [AtlasName.CardsBacks49CardBackPirateShip]: CardsBacks49CardBackPirateShipAtlas,
    [AtlasName.CardsBacks4CardBackRedPattern]: CardsBacks4CardBackRedPatternAtlas,
    [AtlasName.CardsBacks50CardBackCarSunset]: CardsBacks50CardBackCarSunsetAtlas,
    [AtlasName.CardsBacks51CardBackRetroCar]: CardsBacks51CardBackRetroCarAtlas,
    [AtlasName.CardsBacks52CardBackAstronaut]: CardsBacks52CardBackAstronautAtlas,
    [AtlasName.CardsBacks53CardBackCartoonHatCat]: CardsBacks53CardBackCartoonHatCatAtlas,
    [AtlasName.CardsBacks54CardBackFlowerGirl]: CardsBacks54CardBackFlowerGirlAtlas,
    [AtlasName.CardsBacks55CardBackCandy]: CardsBacks55CardBackCandyAtlas,
    [AtlasName.CardsBacks56CardBackPorsche]: CardsBacks56CardBackPorscheAtlas,
    [AtlasName.CardsBacks57CardBackUmbrellas]: CardsBacks57CardBackUmbrellasAtlas,
    [AtlasName.CardsBacks58CardBackChineseLantern]: CardsBacks58CardBackChineseLanternAtlas,
    [AtlasName.CardsBacks59CardBackGoldenCrown]: CardsBacks59CardBackGoldenCrownAtlas,
    [AtlasName.CardsBacks5CardBackBluePattern]: CardsBacks5CardBackBluePatternAtlas,
    [AtlasName.CardsBacks60CardBackPurpleCrown]: CardsBacks60CardBackPurpleCrownAtlas,
    [AtlasName.CardsBacks61CardBackChinesePalace]: CardsBacks61CardBackChinesePalaceAtlas,
    [AtlasName.CardsBacks62CardBackGift]: CardsBacks62CardBackGiftAtlas,
    [AtlasName.CardsBacks63CardBackWinterDog]: CardsBacks63CardBackWinterDogAtlas,
    [AtlasName.CardsBacks64CardBackSnowflakes]: CardsBacks64CardBackSnowflakesAtlas,
    [AtlasName.CardsBacks65CardBackGoldenBird]: CardsBacks65CardBackGoldenBirdAtlas,
    [AtlasName.CardsBacks66CardBackSpider]: CardsBacks66CardBackSpiderAtlas,
    [AtlasName.CardsBacks67CardBackHeartFlowers]: CardsBacks67CardBackHeartFlowersAtlas,
    [AtlasName.CardsBacks68CardBackHeartCat]: CardsBacks68CardBackHeartCatAtlas,
    [AtlasName.CardsBacks69CardBackHeartGlasses]: CardsBacks69CardBackHeartGlassesAtlas,
    [AtlasName.CardsBacks6CardBackOrange]: CardsBacks6CardBackOrangeAtlas,
    [AtlasName.CardsBacks70CardBackHeartDog]: CardsBacks70CardBackHeartDogAtlas,
    [AtlasName.CardsBacks71CardBackClassicBlue]: CardsBacks71CardBackClassicBlueAtlas,
    [AtlasName.CardsBacks72CardBackClassicPurple]: CardsBacks72CardBackClassicPurpleAtlas,
    [AtlasName.CardsBacks73CardBackClassicRed]: CardsBacks73CardBackClassicRedAtlas,
    [AtlasName.CardsBacks74CardBackPanda]: CardsBacks74CardBackPandaAtlas,
    [AtlasName.CardsBacks75CardBackPandaLeaves]: CardsBacks75CardBackPandaLeavesAtlas,
    [AtlasName.CardsBacks76CardBackPalace]: CardsBacks76CardBackPalaceAtlas,
    [AtlasName.CardsBacks77CardBackHalloween]: CardsBacks77CardBackHalloweenAtlas,
    [AtlasName.CardsBacks78CardBackAutumn]: CardsBacks78CardBackAutumnAtlas,
    [AtlasName.CardsBacks79CardBackHalloweenCastle]: CardsBacks79CardBackHalloweenCastleAtlas,
    [AtlasName.CardsBacks7CardBackGingerKitten]: CardsBacks7CardBackGingerKittenAtlas,
    [AtlasName.CardsBacks80CardBackHalloweenPumpkin]: CardsBacks80CardBackHalloweenPumpkinAtlas,
    [AtlasName.CardsBacks81CardBackHalloweenMoon]: CardsBacks81CardBackHalloweenMoonAtlas,
    [AtlasName.CardsBacks82CardBackHalloweenMushroom]: CardsBacks82CardBackHalloweenMushroomAtlas,
    [AtlasName.CardsBacks8CardBackCatHead]: CardsBacks8CardBackCatHeadAtlas,
    [AtlasName.CardsBacks9CardBackChineseCat]: CardsBacks9CardBackChineseCatAtlas,
    [AtlasName.CardsFront10Cartoonish0]: CardsFront10Cartoonish0Atlas,
    [AtlasName.CardsFront10Cartoonish1]: CardsFront10Cartoonish1Atlas,
    [AtlasName.CardsFront10Cartoonish2]: CardsFront10Cartoonish2Atlas,
    [AtlasName.CardsFront10Cartoonish3]: CardsFront10Cartoonish3Atlas,
    [AtlasName.CardsFront10Cartoonish4]: CardsFront10Cartoonish4Atlas,
    [AtlasName.CardsFront10Cartoonish5]: CardsFront10Cartoonish5Atlas,
    [AtlasName.CardsFront10Cartoonish6]: CardsFront10Cartoonish6Atlas,
    [AtlasName.CardsFront10Cartoonish7]: CardsFront10Cartoonish7Atlas,
    [AtlasName.CardsFront10Cartoonish8]: CardsFront10Cartoonish8Atlas,
    [AtlasName.CardsFront11WhiteLarge0]: CardsFront11WhiteLarge0Atlas,
    [AtlasName.CardsFront11WhiteLarge1]: CardsFront11WhiteLarge1Atlas,
    [AtlasName.CardsFront11WhiteLarge2]: CardsFront11WhiteLarge2Atlas,
    [AtlasName.CardsFront11WhiteLarge3]: CardsFront11WhiteLarge3Atlas,
    [AtlasName.CardsFront11WhiteLarge4]: CardsFront11WhiteLarge4Atlas,
    [AtlasName.CardsFront12ClassicLarge0]: CardsFront12ClassicLarge0Atlas,
    [AtlasName.CardsFront12ClassicLarge1]: CardsFront12ClassicLarge1Atlas,
    [AtlasName.CardsFront12ClassicLarge2]: CardsFront12ClassicLarge2Atlas,
    [AtlasName.CardsFront12ClassicLarge3]: CardsFront12ClassicLarge3Atlas,
    [AtlasName.CardsFront12ClassicLarge4]: CardsFront12ClassicLarge4Atlas,
    [AtlasName.CardsFront13Classic0]: CardsFront13Classic0Atlas,
    [AtlasName.CardsFront13Classic1]: CardsFront13Classic1Atlas,
    [AtlasName.CardsFront13Classic2]: CardsFront13Classic2Atlas,
    [AtlasName.CardsFront13Classic3]: CardsFront13Classic3Atlas,
    [AtlasName.CardsFront13Classic4]: CardsFront13Classic4Atlas,
    [AtlasName.CardsFront1White0]: CardsFront1White0Atlas,
    [AtlasName.CardsFront1White1]: CardsFront1White1Atlas,
    [AtlasName.CardsFront1White2]: CardsFront1White2Atlas,
    [AtlasName.CardsFront1White3]: CardsFront1White3Atlas,
    [AtlasName.CardsFront1White4]: CardsFront1White4Atlas,
    [AtlasName.CardsFront1White5]: CardsFront1White5Atlas,
    [AtlasName.CardsFront1White6]: CardsFront1White6Atlas,
    [AtlasName.CardsFront1White7]: CardsFront1White7Atlas,
    [AtlasName.CardsFront1White8]: CardsFront1White8Atlas,
    [AtlasName.CardsFront2Ivory0]: CardsFront2Ivory0Atlas,
    [AtlasName.CardsFront2Ivory1]: CardsFront2Ivory1Atlas,
    [AtlasName.CardsFront2Ivory2]: CardsFront2Ivory2Atlas,
    [AtlasName.CardsFront2Ivory3]: CardsFront2Ivory3Atlas,
    [AtlasName.CardsFront2Ivory4]: CardsFront2Ivory4Atlas,
    [AtlasName.CardsFront2Ivory5]: CardsFront2Ivory5Atlas,
    [AtlasName.CardsFront2Ivory6]: CardsFront2Ivory6Atlas,
    [AtlasName.CardsFront2Ivory7]: CardsFront2Ivory7Atlas,
    [AtlasName.CardsFront2Ivory8]: CardsFront2Ivory8Atlas,
    [AtlasName.CardsFront3Medieval0]: CardsFront3Medieval0Atlas,
    [AtlasName.CardsFront3Medieval1]: CardsFront3Medieval1Atlas,
    [AtlasName.CardsFront3Medieval2]: CardsFront3Medieval2Atlas,
    [AtlasName.CardsFront3Medieval3]: CardsFront3Medieval3Atlas,
    [AtlasName.CardsFront3Medieval4]: CardsFront3Medieval4Atlas,
    [AtlasName.CardsFront3Medieval5]: CardsFront3Medieval5Atlas,
    [AtlasName.CardsFront3Medieval6]: CardsFront3Medieval6Atlas,
    [AtlasName.CardsFront3Medieval7]: CardsFront3Medieval7Atlas,
    [AtlasName.CardsFront3Medieval8]: CardsFront3Medieval8Atlas,
    [AtlasName.CardsFront4Gothic0]: CardsFront4Gothic0Atlas,
    [AtlasName.CardsFront4Gothic1]: CardsFront4Gothic1Atlas,
    [AtlasName.CardsFront4Gothic2]: CardsFront4Gothic2Atlas,
    [AtlasName.CardsFront4Gothic3]: CardsFront4Gothic3Atlas,
    [AtlasName.CardsFront4Gothic4]: CardsFront4Gothic4Atlas,
    [AtlasName.CardsFront4Gothic5]: CardsFront4Gothic5Atlas,
    [AtlasName.CardsFront4Gothic6]: CardsFront4Gothic6Atlas,
    [AtlasName.CardsFront4Gothic7]: CardsFront4Gothic7Atlas,
    [AtlasName.CardsFront4Gothic8]: CardsFront4Gothic8Atlas,
    [AtlasName.CardsFront5Cats0]: CardsFront5Cats0Atlas,
    [AtlasName.CardsFront5Cats1]: CardsFront5Cats1Atlas,
    [AtlasName.CardsFront5Cats2]: CardsFront5Cats2Atlas,
    [AtlasName.CardsFront5Cats3]: CardsFront5Cats3Atlas,
    [AtlasName.CardsFront5Cats4]: CardsFront5Cats4Atlas,
    [AtlasName.CardsFront5Cats5]: CardsFront5Cats5Atlas,
    [AtlasName.CardsFront5Cats6]: CardsFront5Cats6Atlas,
    [AtlasName.CardsFront5Cats7]: CardsFront5Cats7Atlas,
    [AtlasName.CardsFront5Cats8]: CardsFront5Cats8Atlas,
    [AtlasName.CardsFront6Dogs0]: CardsFront6Dogs0Atlas,
    [AtlasName.CardsFront6Dogs1]: CardsFront6Dogs1Atlas,
    [AtlasName.CardsFront6Dogs2]: CardsFront6Dogs2Atlas,
    [AtlasName.CardsFront6Dogs3]: CardsFront6Dogs3Atlas,
    [AtlasName.CardsFront6Dogs4]: CardsFront6Dogs4Atlas,
    [AtlasName.CardsFront6Dogs5]: CardsFront6Dogs5Atlas,
    [AtlasName.CardsFront6Dogs6]: CardsFront6Dogs6Atlas,
    [AtlasName.CardsFront6Dogs7]: CardsFront6Dogs7Atlas,
    [AtlasName.CardsFront6Dogs8]: CardsFront6Dogs8Atlas,
    [AtlasName.CardsFront7Elegant0]: CardsFront7Elegant0Atlas,
    [AtlasName.CardsFront7Elegant1]: CardsFront7Elegant1Atlas,
    [AtlasName.CardsFront7Elegant2]: CardsFront7Elegant2Atlas,
    [AtlasName.CardsFront7Elegant3]: CardsFront7Elegant3Atlas,
    [AtlasName.CardsFront7Elegant4]: CardsFront7Elegant4Atlas,
    [AtlasName.CardsFront7Elegant5]: CardsFront7Elegant5Atlas,
    [AtlasName.CardsFront7Elegant6]: CardsFront7Elegant6Atlas,
    [AtlasName.CardsFront7Elegant7]: CardsFront7Elegant7Atlas,
    [AtlasName.CardsFront7Elegant8]: CardsFront7Elegant8Atlas,
    [AtlasName.CardsFront8Neon0]: CardsFront8Neon0Atlas,
    [AtlasName.CardsFront8Neon1]: CardsFront8Neon1Atlas,
    [AtlasName.CardsFront8Neon2]: CardsFront8Neon2Atlas,
    [AtlasName.CardsFront8Neon3]: CardsFront8Neon3Atlas,
    [AtlasName.CardsFront8Neon4]: CardsFront8Neon4Atlas,
    [AtlasName.CardsFront8Neon5]: CardsFront8Neon5Atlas,
    [AtlasName.CardsFront8Neon6]: CardsFront8Neon6Atlas,
    [AtlasName.CardsFront8Neon7]: CardsFront8Neon7Atlas,
    [AtlasName.CardsFront8Neon8]: CardsFront8Neon8Atlas,
    [AtlasName.CardsFront9Retro0]: CardsFront9Retro0Atlas,
    [AtlasName.CardsFront9Retro1]: CardsFront9Retro1Atlas,
    [AtlasName.CardsFront9Retro2]: CardsFront9Retro2Atlas,
    [AtlasName.CardsFront9Retro3]: CardsFront9Retro3Atlas,
    [AtlasName.CardsFront9Retro4]: CardsFront9Retro4Atlas,
    [AtlasName.CardsFront9Retro5]: CardsFront9Retro5Atlas,
    [AtlasName.CardsFront9Retro6]: CardsFront9Retro6Atlas,
    [AtlasName.CardsFront9Retro7]: CardsFront9Retro7Atlas,
    [AtlasName.CardsFront9Retro8]: CardsFront9Retro8Atlas,
    [AtlasName.CardsShadow]: CardsShadowAtlas,
    [AtlasName.Desktop10DarkGreen]: Desktop10DarkGreenAtlas,
    [AtlasName.Desktop11Poppies]: Desktop11PoppiesAtlas,
    [AtlasName.Desktop12GreenField]: Desktop12GreenFieldAtlas,
    [AtlasName.Desktop13Waterfall]: Desktop13WaterfallAtlas,
    [AtlasName.Desktop14Beach]: Desktop14BeachAtlas,
    [AtlasName.Desktop15TurquoiseSkies]: Desktop15TurquoiseSkiesAtlas,
    [AtlasName.Desktop1Green]: Desktop1GreenAtlas,
    [AtlasName.Desktop20Wood]: Desktop20WoodAtlas,
    [AtlasName.Desktop21Peony]: Desktop21PeonyAtlas,
    [AtlasName.Desktop22LonelyMountain]: Desktop22LonelyMountainAtlas,
    [AtlasName.Desktop23FiveCats]: Desktop23FiveCatsAtlas,
    [AtlasName.Desktop24Road]: Desktop24RoadAtlas,
    [AtlasName.Desktop25NewYork]: Desktop25NewYorkAtlas,
    [AtlasName.Desktop26Blossom]: Desktop26BlossomAtlas,
    [AtlasName.Desktop27Clouds]: Desktop27CloudsAtlas,
    [AtlasName.Desktop28MountainLake]: Desktop28MountainLakeAtlas,
    [AtlasName.Desktop2Blue]: Desktop2BlueAtlas,
    [AtlasName.Desktop30Kittens]: Desktop30KittensAtlas,
    [AtlasName.Desktop31Mountains]: Desktop31MountainsAtlas,
    [AtlasName.Desktop32PaintedWall]: Desktop32PaintedWallAtlas,
    [AtlasName.Desktop33WinterNight]: Desktop33WinterNightAtlas,
    [AtlasName.Desktop34ChristmasTree]: Desktop34ChristmasTreeAtlas,
    [AtlasName.Desktop35WinterHouse]: Desktop35WinterHouseAtlas,
    [AtlasName.Desktop36ChristmasWall]: Desktop36ChristmasWallAtlas,
    [AtlasName.Desktop37HeartRoses]: Desktop37HeartRosesAtlas,
    [AtlasName.Desktop38HeartDogs]: Desktop38HeartDogsAtlas,
    [AtlasName.Desktop39Field]: Desktop39FieldAtlas,
    [AtlasName.Desktop3Red]: Desktop3RedAtlas,
    [AtlasName.Desktop40MountainsLake]: Desktop40MountainsLakeAtlas,
    [AtlasName.Desktop41NightSky]: Desktop41NightSkyAtlas,
    [AtlasName.Desktop42NationalPark]: Desktop42NationalParkAtlas,
    [AtlasName.Desktop43Sakura]: Desktop43SakuraAtlas,
    [AtlasName.Desktop44Bridge]: Desktop44BridgeAtlas,
    [AtlasName.Desktop45HalloweenSky]: Desktop45HalloweenSkyAtlas,
    [AtlasName.Desktop46Autumn]: Desktop46AutumnAtlas,
    [AtlasName.Desktop47HalloweenFog]: Desktop47HalloweenFogAtlas,
    [AtlasName.Desktop48HalloweenPumpkin]: Desktop48HalloweenPumpkinAtlas,
    [AtlasName.Desktop49Leaves]: Desktop49LeavesAtlas,
    [AtlasName.Desktop4Orange]: Desktop4OrangeAtlas,
    [AtlasName.Desktop50HalloweenStillLife]: Desktop50HalloweenStillLifeAtlas,
    [AtlasName.Desktop5Olive]: Desktop5OliveAtlas,
    [AtlasName.Desktop6Turquoise]: Desktop6TurquoiseAtlas,
    [AtlasName.Desktop7Burgundy]: Desktop7BurgundyAtlas,
    [AtlasName.Desktop8DarkPurple]: Desktop8DarkPurpleAtlas,
    [AtlasName.Desktop9Purple]: Desktop9PurpleAtlas,
    [AtlasName.Mobile10DarkGreen]: Mobile10DarkGreenAtlas,
    [AtlasName.Mobile12GreenField]: Mobile12GreenFieldAtlas,
    [AtlasName.Mobile13Waterfall]: Mobile13WaterfallAtlas,
    [AtlasName.Mobile14Beach]: Mobile14BeachAtlas,
    [AtlasName.Mobile15TurquoiseSkies]: Mobile15TurquoiseSkiesAtlas,
    [AtlasName.Mobile1Green]: Mobile1GreenAtlas,
    [AtlasName.Mobile20Wood]: Mobile20WoodAtlas,
    [AtlasName.Mobile21Peony]: Mobile21PeonyAtlas,
    [AtlasName.Mobile22LonelyMountain]: Mobile22LonelyMountainAtlas,
    [AtlasName.Mobile23FiveCats]: Mobile23FiveCatsAtlas,
    [AtlasName.Mobile24Road]: Mobile24RoadAtlas,
    [AtlasName.Mobile25NewYork]: Mobile25NewYorkAtlas,
    [AtlasName.Mobile26Blossom]: Mobile26BlossomAtlas,
    [AtlasName.Mobile27Clouds]: Mobile27CloudsAtlas,
    [AtlasName.Mobile28MountainLake]: Mobile28MountainLakeAtlas,
    [AtlasName.Mobile2Blue]: Mobile2BlueAtlas,
    [AtlasName.Mobile30Kittens]: Mobile30KittensAtlas,
    [AtlasName.Mobile31Mountains]: Mobile31MountainsAtlas,
    [AtlasName.Mobile32PaintedWall]: Mobile32PaintedWallAtlas,
    [AtlasName.Mobile33WinterNight]: Mobile33WinterNightAtlas,
    [AtlasName.Mobile33WonterNight]: Mobile33WonterNightAtlas,
    [AtlasName.Mobile34ChristmasTree]: Mobile34ChristmasTreeAtlas,
    [AtlasName.Mobile35WinterHouse]: Mobile35WinterHouseAtlas,
    [AtlasName.Mobile36ChristmasWall]: Mobile36ChristmasWallAtlas,
    [AtlasName.Mobile37HeartRoses]: Mobile37HeartRosesAtlas,
    [AtlasName.Mobile38HeartDogs]: Mobile38HeartDogsAtlas,
    [AtlasName.Mobile39Field]: Mobile39FieldAtlas,
    [AtlasName.Mobile3Red]: Mobile3RedAtlas,
    [AtlasName.Mobile40MountainsLake]: Mobile40MountainsLakeAtlas,
    [AtlasName.Mobile41NightSky]: Mobile41NightSkyAtlas,
    [AtlasName.Mobile42NationalPark]: Mobile42NationalParkAtlas,
    [AtlasName.Mobile43Sakura]: Mobile43SakuraAtlas,
    [AtlasName.Mobile44Bridge]: Mobile44BridgeAtlas,
    [AtlasName.Mobile45HalloweenSky]: Mobile45HalloweenSkyAtlas,
    [AtlasName.Mobile46Autumn]: Mobile46AutumnAtlas,
    [AtlasName.Mobile47HalloweenFog]: Mobile47HalloweenFogAtlas,
    [AtlasName.Mobile48HalloweenPumpkin]: Mobile48HalloweenPumpkinAtlas,
    [AtlasName.Mobile49Leaves]: Mobile49LeavesAtlas,
    [AtlasName.Mobile4Orange]: Mobile4OrangeAtlas,
    [AtlasName.Mobile50HalloweenStillLife]: Mobile50HalloweenStillLifeAtlas,
    [AtlasName.Mobile5Olive]: Mobile5OliveAtlas,
    [AtlasName.Mobile6Turquoise]: Mobile6TurquoiseAtlas,
    [AtlasName.Mobile7Burgundy]: Mobile7BurgundyAtlas,
    [AtlasName.Mobile8DarkPurple]: Mobile8DarkPurpleAtlas,
    [AtlasName.Mobile9Purple]: Mobile9PurpleAtlas,
    [AtlasName.Particles]: ParticlesAtlas,
    [AtlasName.Placeholders]: PlaceholdersAtlas,
    [AtlasName.Tablet10DarkGreen]: Tablet10DarkGreenAtlas,
    [AtlasName.Tablet11Poppies]: Tablet11PoppiesAtlas,
    [AtlasName.Tablet12GreenField]: Tablet12GreenFieldAtlas,
    [AtlasName.Tablet13Waterfall]: Tablet13WaterfallAtlas,
    [AtlasName.Tablet14Beach]: Tablet14BeachAtlas,
    [AtlasName.Tablet15TurquoiseSkies]: Tablet15TurquoiseSkiesAtlas,
    [AtlasName.Tablet1Green]: Tablet1GreenAtlas,
    [AtlasName.Tablet20Wood]: Tablet20WoodAtlas,
    [AtlasName.Tablet21Peony]: Tablet21PeonyAtlas,
    [AtlasName.Tablet22LonelyMountain]: Tablet22LonelyMountainAtlas,
    [AtlasName.Tablet23FiveCats]: Tablet23FiveCatsAtlas,
    [AtlasName.Tablet24Road]: Tablet24RoadAtlas,
    [AtlasName.Tablet25NewYork]: Tablet25NewYorkAtlas,
    [AtlasName.Tablet26Blossom]: Tablet26BlossomAtlas,
    [AtlasName.Tablet27Clouds]: Tablet27CloudsAtlas,
    [AtlasName.Tablet28MountainLake]: Tablet28MountainLakeAtlas,
    [AtlasName.Tablet2Blue]: Tablet2BlueAtlas,
    [AtlasName.Tablet30Kittens]: Tablet30KittensAtlas,
    [AtlasName.Tablet31Mountains]: Tablet31MountainsAtlas,
    [AtlasName.Tablet32PaintedWall]: Tablet32PaintedWallAtlas,
    [AtlasName.Tablet33WinterNight]: Tablet33WinterNightAtlas,
    [AtlasName.Tablet34ChristmasTree]: Tablet34ChristmasTreeAtlas,
    [AtlasName.Tablet35WinterHouse]: Tablet35WinterHouseAtlas,
    [AtlasName.Tablet36ChristmasWall]: Tablet36ChristmasWallAtlas,
    [AtlasName.Tablet37HeartRoses]: Tablet37HeartRosesAtlas,
    [AtlasName.Tablet38HeartDogs]: Tablet38HeartDogsAtlas,
    [AtlasName.Tablet39Field]: Tablet39FieldAtlas,
    [AtlasName.Tablet3Red]: Tablet3RedAtlas,
    [AtlasName.Tablet40MountainsLake]: Tablet40MountainsLakeAtlas,
    [AtlasName.Tablet41NightSky]: Tablet41NightSkyAtlas,
    [AtlasName.Tablet42NationalPark]: Tablet42NationalParkAtlas,
    [AtlasName.Tablet43Sakura]: Tablet43SakuraAtlas,
    [AtlasName.Tablet44Bridge]: Tablet44BridgeAtlas,
    [AtlasName.Tablet45HalloweenSky]: Tablet45HalloweenSkyAtlas,
    [AtlasName.Tablet46Autumn]: Tablet46AutumnAtlas,
    [AtlasName.Tablet47HalloweenFog]: Tablet47HalloweenFogAtlas,
    [AtlasName.Tablet48HalloweenPumpkin]: Tablet48HalloweenPumpkinAtlas,
    [AtlasName.Tablet49Leaves]: Tablet49LeavesAtlas,
    [AtlasName.Tablet4Orange]: Tablet4OrangeAtlas,
    [AtlasName.Tablet50HalloweenStillLife]: Tablet50HalloweenStillLifeAtlas,
    [AtlasName.Tablet5Olive]: Tablet5OliveAtlas,
    [AtlasName.Tablet6Turquoise]: Tablet6TurquoiseAtlas,
    [AtlasName.Tablet7Burgundy]: Tablet7BurgundyAtlas,
    [AtlasName.Tablet8DarkPurple]: Tablet8DarkPurpleAtlas,
    [AtlasName.Tablet9Purple]: Tablet9PurpleAtlas,
} as const;

/**
 * List of all atlas names
 */
export const ATLAS_NAMES = Object.values(AtlasName);

// Re-export all atlases for convenient import
export {
    CardglowAtlas,
    CardsBacks10CardBackCatCrownAtlas,
    CardsBacks11CardBackCatGlassesAtlas,
    CardsBacks12CardBackMonarchDogAtlas,
    CardsBacks13CardBackHappyCartoonDogAtlas,
    CardsBacks14CardBackWhitePuppyAtlas,
    CardsBacks15CardBackIslandAtlas,
    CardsBacks16CardBackCrownedDogAtlas,
    CardsBacks17CardBackRosesAtlas,
    CardsBacks18CardBackSunflowersAtlas,
    CardsBacks19CardBackRosehipAtlas,
    CardsBacks1CardBackBlueAtlas,
    CardsBacks20CardBackFloralPrintAtlas,
    CardsBacks21CardBackOrchidsAtlas,
    CardsBacks22CardBackSakuraAtlas,
    CardsBacks23CardBackBeeAtlas,
    CardsBacks24CardBackButterflyAtlas,
    CardsBacks25CardBackLadybugAtlas,
    CardsBacks26CardBackCalibriAtlas,
    CardsBacks27CardBackOwlAtlas,
    CardsBacks28CardBackToucanAtlas,
    CardsBacks29CardBackSwanAtlas,
    CardsBacks2CardBackBlueDarkAtlas,
    CardsBacks30CardBackBambooBearAtlas,
    CardsBacks31CardBackLeopardAtlas,
    CardsBacks32CardBackLionAtlas,
    CardsBacks33CardBackDeerAtlas,
    CardsBacks34CardBackPolarBearAtlas,
    CardsBacks35CardBackPagodaAtlas,
    CardsBacks36CardBackYorkshireTerrierAtlas,
    CardsBacks37CardBackJapaneseSceneryAtlas,
    CardsBacks38CardBackMuseumAtlas,
    CardsBacks39CardBackPalaceAtlas,
    CardsBacks3CardBackRedAtlas,
    CardsBacks40CardBackCastleAtlas,
    CardsBacks41CardBackWhiteDomeAtlas,
    CardsBacks42CardBackEiffelTowerAtlas,
    CardsBacks43CardBackHydrangeasAtlas,
    CardsBacks44CardBackChineseWallAtlas,
    CardsBacks45CardBackAstrologyAtlas,
    CardsBacks46CardBackSkyAtlas,
    CardsBacks47CardBackShellsAtlas,
    CardsBacks48CardBackYachtAtlas,
    CardsBacks49CardBackPirateShipAtlas,
    CardsBacks4CardBackRedPatternAtlas,
    CardsBacks50CardBackCarSunsetAtlas,
    CardsBacks51CardBackRetroCarAtlas,
    CardsBacks52CardBackAstronautAtlas,
    CardsBacks53CardBackCartoonHatCatAtlas,
    CardsBacks54CardBackFlowerGirlAtlas,
    CardsBacks55CardBackCandyAtlas,
    CardsBacks56CardBackPorscheAtlas,
    CardsBacks57CardBackUmbrellasAtlas,
    CardsBacks58CardBackChineseLanternAtlas,
    CardsBacks59CardBackGoldenCrownAtlas,
    CardsBacks5CardBackBluePatternAtlas,
    CardsBacks60CardBackPurpleCrownAtlas,
    CardsBacks61CardBackChinesePalaceAtlas,
    CardsBacks62CardBackGiftAtlas,
    CardsBacks63CardBackWinterDogAtlas,
    CardsBacks64CardBackSnowflakesAtlas,
    CardsBacks65CardBackGoldenBirdAtlas,
    CardsBacks66CardBackSpiderAtlas,
    CardsBacks67CardBackHeartFlowersAtlas,
    CardsBacks68CardBackHeartCatAtlas,
    CardsBacks69CardBackHeartGlassesAtlas,
    CardsBacks6CardBackOrangeAtlas,
    CardsBacks70CardBackHeartDogAtlas,
    CardsBacks71CardBackClassicBlueAtlas,
    CardsBacks72CardBackClassicPurpleAtlas,
    CardsBacks73CardBackClassicRedAtlas,
    CardsBacks74CardBackPandaAtlas,
    CardsBacks75CardBackPandaLeavesAtlas,
    CardsBacks76CardBackPalaceAtlas,
    CardsBacks77CardBackHalloweenAtlas,
    CardsBacks78CardBackAutumnAtlas,
    CardsBacks79CardBackHalloweenCastleAtlas,
    CardsBacks7CardBackGingerKittenAtlas,
    CardsBacks80CardBackHalloweenPumpkinAtlas,
    CardsBacks81CardBackHalloweenMoonAtlas,
    CardsBacks82CardBackHalloweenMushroomAtlas,
    CardsBacks8CardBackCatHeadAtlas,
    CardsBacks9CardBackChineseCatAtlas,
    CardsFront10Cartoonish0Atlas,
    CardsFront10Cartoonish1Atlas,
    CardsFront10Cartoonish2Atlas,
    CardsFront10Cartoonish3Atlas,
    CardsFront10Cartoonish4Atlas,
    CardsFront10Cartoonish5Atlas,
    CardsFront10Cartoonish6Atlas,
    CardsFront10Cartoonish7Atlas,
    CardsFront10Cartoonish8Atlas,
    CardsFront11WhiteLarge0Atlas,
    CardsFront11WhiteLarge1Atlas,
    CardsFront11WhiteLarge2Atlas,
    CardsFront11WhiteLarge3Atlas,
    CardsFront11WhiteLarge4Atlas,
    CardsFront12ClassicLarge0Atlas,
    CardsFront12ClassicLarge1Atlas,
    CardsFront12ClassicLarge2Atlas,
    CardsFront12ClassicLarge3Atlas,
    CardsFront12ClassicLarge4Atlas,
    CardsFront13Classic0Atlas,
    CardsFront13Classic1Atlas,
    CardsFront13Classic2Atlas,
    CardsFront13Classic3Atlas,
    CardsFront13Classic4Atlas,
    CardsFront1White0Atlas,
    CardsFront1White1Atlas,
    CardsFront1White2Atlas,
    CardsFront1White3Atlas,
    CardsFront1White4Atlas,
    CardsFront1White5Atlas,
    CardsFront1White6Atlas,
    CardsFront1White7Atlas,
    CardsFront1White8Atlas,
    CardsFront2Ivory0Atlas,
    CardsFront2Ivory1Atlas,
    CardsFront2Ivory2Atlas,
    CardsFront2Ivory3Atlas,
    CardsFront2Ivory4Atlas,
    CardsFront2Ivory5Atlas,
    CardsFront2Ivory6Atlas,
    CardsFront2Ivory7Atlas,
    CardsFront2Ivory8Atlas,
    CardsFront3Medieval0Atlas,
    CardsFront3Medieval1Atlas,
    CardsFront3Medieval2Atlas,
    CardsFront3Medieval3Atlas,
    CardsFront3Medieval4Atlas,
    CardsFront3Medieval5Atlas,
    CardsFront3Medieval6Atlas,
    CardsFront3Medieval7Atlas,
    CardsFront3Medieval8Atlas,
    CardsFront4Gothic0Atlas,
    CardsFront4Gothic1Atlas,
    CardsFront4Gothic2Atlas,
    CardsFront4Gothic3Atlas,
    CardsFront4Gothic4Atlas,
    CardsFront4Gothic5Atlas,
    CardsFront4Gothic6Atlas,
    CardsFront4Gothic7Atlas,
    CardsFront4Gothic8Atlas,
    CardsFront5Cats0Atlas,
    CardsFront5Cats1Atlas,
    CardsFront5Cats2Atlas,
    CardsFront5Cats3Atlas,
    CardsFront5Cats4Atlas,
    CardsFront5Cats5Atlas,
    CardsFront5Cats6Atlas,
    CardsFront5Cats7Atlas,
    CardsFront5Cats8Atlas,
    CardsFront6Dogs0Atlas,
    CardsFront6Dogs1Atlas,
    CardsFront6Dogs2Atlas,
    CardsFront6Dogs3Atlas,
    CardsFront6Dogs4Atlas,
    CardsFront6Dogs5Atlas,
    CardsFront6Dogs6Atlas,
    CardsFront6Dogs7Atlas,
    CardsFront6Dogs8Atlas,
    CardsFront7Elegant0Atlas,
    CardsFront7Elegant1Atlas,
    CardsFront7Elegant2Atlas,
    CardsFront7Elegant3Atlas,
    CardsFront7Elegant4Atlas,
    CardsFront7Elegant5Atlas,
    CardsFront7Elegant6Atlas,
    CardsFront7Elegant7Atlas,
    CardsFront7Elegant8Atlas,
    CardsFront8Neon0Atlas,
    CardsFront8Neon1Atlas,
    CardsFront8Neon2Atlas,
    CardsFront8Neon3Atlas,
    CardsFront8Neon4Atlas,
    CardsFront8Neon5Atlas,
    CardsFront8Neon6Atlas,
    CardsFront8Neon7Atlas,
    CardsFront8Neon8Atlas,
    CardsFront9Retro0Atlas,
    CardsFront9Retro1Atlas,
    CardsFront9Retro2Atlas,
    CardsFront9Retro3Atlas,
    CardsFront9Retro4Atlas,
    CardsFront9Retro5Atlas,
    CardsFront9Retro6Atlas,
    CardsFront9Retro7Atlas,
    CardsFront9Retro8Atlas,
    CardsShadowAtlas,
    Desktop10DarkGreenAtlas,
    Desktop11PoppiesAtlas,
    Desktop12GreenFieldAtlas,
    Desktop13WaterfallAtlas,
    Desktop14BeachAtlas,
    Desktop15TurquoiseSkiesAtlas,
    Desktop1GreenAtlas,
    Desktop20WoodAtlas,
    Desktop21PeonyAtlas,
    Desktop22LonelyMountainAtlas,
    Desktop23FiveCatsAtlas,
    Desktop24RoadAtlas,
    Desktop25NewYorkAtlas,
    Desktop26BlossomAtlas,
    Desktop27CloudsAtlas,
    Desktop28MountainLakeAtlas,
    Desktop2BlueAtlas,
    Desktop30KittensAtlas,
    Desktop31MountainsAtlas,
    Desktop32PaintedWallAtlas,
    Desktop33WinterNightAtlas,
    Desktop34ChristmasTreeAtlas,
    Desktop35WinterHouseAtlas,
    Desktop36ChristmasWallAtlas,
    Desktop37HeartRosesAtlas,
    Desktop38HeartDogsAtlas,
    Desktop39FieldAtlas,
    Desktop3RedAtlas,
    Desktop40MountainsLakeAtlas,
    Desktop41NightSkyAtlas,
    Desktop42NationalParkAtlas,
    Desktop43SakuraAtlas,
    Desktop44BridgeAtlas,
    Desktop45HalloweenSkyAtlas,
    Desktop46AutumnAtlas,
    Desktop47HalloweenFogAtlas,
    Desktop48HalloweenPumpkinAtlas,
    Desktop49LeavesAtlas,
    Desktop4OrangeAtlas,
    Desktop50HalloweenStillLifeAtlas,
    Desktop5OliveAtlas,
    Desktop6TurquoiseAtlas,
    Desktop7BurgundyAtlas,
    Desktop8DarkPurpleAtlas,
    Desktop9PurpleAtlas,
    Mobile10DarkGreenAtlas,
    Mobile12GreenFieldAtlas,
    Mobile13WaterfallAtlas,
    Mobile14BeachAtlas,
    Mobile15TurquoiseSkiesAtlas,
    Mobile1GreenAtlas,
    Mobile20WoodAtlas,
    Mobile21PeonyAtlas,
    Mobile22LonelyMountainAtlas,
    Mobile23FiveCatsAtlas,
    Mobile24RoadAtlas,
    Mobile25NewYorkAtlas,
    Mobile26BlossomAtlas,
    Mobile27CloudsAtlas,
    Mobile28MountainLakeAtlas,
    Mobile2BlueAtlas,
    Mobile30KittensAtlas,
    Mobile31MountainsAtlas,
    Mobile32PaintedWallAtlas,
    Mobile33WinterNightAtlas,
    Mobile33WonterNightAtlas,
    Mobile34ChristmasTreeAtlas,
    Mobile35WinterHouseAtlas,
    Mobile36ChristmasWallAtlas,
    Mobile37HeartRosesAtlas,
    Mobile38HeartDogsAtlas,
    Mobile39FieldAtlas,
    Mobile3RedAtlas,
    Mobile40MountainsLakeAtlas,
    Mobile41NightSkyAtlas,
    Mobile42NationalParkAtlas,
    Mobile43SakuraAtlas,
    Mobile44BridgeAtlas,
    Mobile45HalloweenSkyAtlas,
    Mobile46AutumnAtlas,
    Mobile47HalloweenFogAtlas,
    Mobile48HalloweenPumpkinAtlas,
    Mobile49LeavesAtlas,
    Mobile4OrangeAtlas,
    Mobile50HalloweenStillLifeAtlas,
    Mobile5OliveAtlas,
    Mobile6TurquoiseAtlas,
    Mobile7BurgundyAtlas,
    Mobile8DarkPurpleAtlas,
    Mobile9PurpleAtlas,
    ParticlesAtlas,
    PlaceholdersAtlas,
    Tablet10DarkGreenAtlas,
    Tablet11PoppiesAtlas,
    Tablet12GreenFieldAtlas,
    Tablet13WaterfallAtlas,
    Tablet14BeachAtlas,
    Tablet15TurquoiseSkiesAtlas,
    Tablet1GreenAtlas,
    Tablet20WoodAtlas,
    Tablet21PeonyAtlas,
    Tablet22LonelyMountainAtlas,
    Tablet23FiveCatsAtlas,
    Tablet24RoadAtlas,
    Tablet25NewYorkAtlas,
    Tablet26BlossomAtlas,
    Tablet27CloudsAtlas,
    Tablet28MountainLakeAtlas,
    Tablet2BlueAtlas,
    Tablet30KittensAtlas,
    Tablet31MountainsAtlas,
    Tablet32PaintedWallAtlas,
    Tablet33WinterNightAtlas,
    Tablet34ChristmasTreeAtlas,
    Tablet35WinterHouseAtlas,
    Tablet36ChristmasWallAtlas,
    Tablet37HeartRosesAtlas,
    Tablet38HeartDogsAtlas,
    Tablet39FieldAtlas,
    Tablet3RedAtlas,
    Tablet40MountainsLakeAtlas,
    Tablet41NightSkyAtlas,
    Tablet42NationalParkAtlas,
    Tablet43SakuraAtlas,
    Tablet44BridgeAtlas,
    Tablet45HalloweenSkyAtlas,
    Tablet46AutumnAtlas,
    Tablet47HalloweenFogAtlas,
    Tablet48HalloweenPumpkinAtlas,
    Tablet49LeavesAtlas,
    Tablet4OrangeAtlas,
    Tablet50HalloweenStillLifeAtlas,
    Tablet5OliveAtlas,
    Tablet6TurquoiseAtlas,
    Tablet7BurgundyAtlas,
    Tablet8DarkPurpleAtlas,
    Tablet9PurpleAtlas,
};
